import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Editor, Toolbar, Validators, toDoc, toHTML } from 'ngx-editor';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { KeyWord } from 'src/app/shared/classes/constants';
import { ThemingService } from 'src/app/shared/services/theming.service';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import Quill from 'quill';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';
import prettify from '@liquify/prettify';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import Gleap from 'gleap';
import { CompetitorsOutlineComponent } from '../competitors-outline/competitors-outline.component';
import { MatMenuTrigger } from '@angular/material/menu';
import BlotFormatter from 'quill-blot-formatter';
import { CustomUrlComponent } from '../custom-url/custom-url.component';

Quill.register('modules/blotFormatter', (BlotFormatter as any));
const icons: any = Quill.import('ui/icons');
const BlockEmbed = Quill.import('blots/block/embed');

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class TextEditorComponent implements OnInit, AfterViewInit, OnDestroy {
  window: any = window;
  intregtedAccount: any = []
  @ViewChild("myChart") ctx: any;
  @ViewChild('Topic') trigger: any;

  contentDataViaUrl: any = {}
  activeLink = 'Keyword';
  activeKeyWord = 'Main content';
  activeBriefKeyWord = 'H2 brief';
  panelOpenState: boolean = false;
  isTable: boolean = false;
  panelOpenState1: boolean = true;
  panelOpenState2: boolean = false;
  dataSetValues = [10, 23, 33, 33];
  baseOutlineData: any[] = [];
  dataSetColors = ["rgba(221, 222, 228, 0)", "rgba(221, 222, 228, 0)", "rgba(221, 222, 228, 0)", "rgba(221, 222, 228, 0)"]
  gradient: any
  newBaseOutlineData: any[] = [];
  editor!: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  editorContent = new FormControl(
    { value: '', disabled: false },
    Validators.required()
  )
  progressChart: any
  addUrl = new FormControl();
  H1BriefData = KeyWord.H1BriefData;
  peopleAlsoAskTab = KeyWord.PeopleAlsoAskTab;
  progressRange = 0;
  h2Tag: string = "";
  h3Tag: string = "";
  currentDrag: any = {};
  // topCompititorTitle = KeyWord.TopCompititorTitle;
  isChecked: boolean = true;
  arr = new Array(3)
  isCollapse: boolean = false;
  addH2Tage: boolean = false;
  addH3Tage: boolean = false;
  colorarr = ['bg-green', 'bg-pink', 'bg-orange'];
  colorbgArr = ['btn-sky-blue', 'btn-light-pink', ' btn-orange']
  colorindex = Math.floor(Math.random() * this.colorarr.length)
  editorData: any = {}
  keywords: any;
  keywords_h1: any;
  keywords_h2: any;
  keywords_title: any;
  html: any = "";
  theme: boolean = true;
  timeoutId: any = null;
  allData: any[] = [];
  titleData: any[] = [];
  h1Data: any[] = [];
  h2Data: any[] = [];
  top3Data: any[] = [];
  nlpData: any[] = [];
  mainContentData: any[] = [];
  searchBriefText: string = "";
  loading: boolean = false;
  titleField: string = "";
  metaField: string = "";
  subscriptions = {};
  searchText: string = "";
  h1Brief: any[] = [];
  h2Brief: any[] = [];
  backupH2Brief: any[] = [];
  h3Brief: any[] = [];
  backupH3Brief: any[] = [];
  visiblityFilter: any[] = [];
  topCompititiorTitle: any[] = [];
  Object = Object;
  termsSettings: any[] = [];
  termsSettingsBackup: any[] = [];
  modalValue: any[] = [];
  base: any;
  titleTimoutId: any = null;
  metaTimoutId: any = null;
  score = 0;
  isLoading = false
  quillEditor: any;
  termsVisiblityArr = KeyWord.termsVisiblity;
  checkOutline: boolean = false;
  textChangeCount: number = 0;
  tagArray: any = [];
  userName: any = '';
  isChangeOccured: boolean = false;
  isSaving: boolean = false;
  structureObj: any = [
    { key: "Body", latestCount: 0, min: null, max: null },
    { key: "Paragraph", latestCount: 0, min: null, max: null },
    { key: "Title", latestCount: 0, min: null, max: null },
    { key: "H2", latestCount: 0, min: null, max: null },
    { key: "H3", latestCount: 0, min: null, max: null },
    { key: "H4-H6", latestCount: 0, min: null, max: null },
    { key: "Bold/B", latestCount: 0, min: null, max: null }
  ];
  density: any = [
    { key: "Title", latestCount: 0, min: 0, max: 1 },
    { key: "H1", latestCount: 0, min: 0, max: 1 },
    { key: "Body", latestCount: 0, min: 0, max: 1 },
    { key: "Paragraph", latestCount: 0, min: 0, max: 0 },
    { key: "H2", latestCount: 0, min: 0, max: 0 },
    { key: "H3", latestCount: 0, min: 0, max: 0 },
    { key: "H4-H6", latestCount: 0, min: 0, max: 0 },
    { key: "Bold/B", latestCount: 0, min: 0, max: 0 }
  ];
  characters: any = [
    { key: "Title", latestWordCount: 0, min: null, max: null },
    { key: "Meta description", latestWordCount: 0, min: 50, max: 160 },
  ]
  elements: any = [
    { key: "H1", latestElementCount: 0, min: 0, max: 1 },
    { key: "H2", latestElementCount: 0, min: null, max: null },
    { key: "H3", latestElementCount: 0, min: null, max: null },
    { key: "H4-H6", latestElementCount: 0, min: null, max: null },
    { key: "Paragraph", latestElementCount: 0, min: null, max: null },
    { key: "Strong/B", latestElementCount: 0, min: null, max: null },
    { key: "Image", latestElementCount: 0, min: null, max: null },
  ];
  sidebarArray = ["Keyword Details", "Content score", "Content structure"]
  @ViewChild("quill") private quill!: any;
  isoptimised: boolean = false;
  isPartial: boolean = false;
  isNotUsed: boolean = false;
  isShowRanges: boolean = true;
  cid: string = "";
  checkObj: boolean = false;
  checkBaseOutline: boolean = false;
  checkStrucutureObj: boolean = false;
  backupTermsSettings: any[] = [];
  scrollTop: any;
  undoCount = 0;
  redoCouunt = 0;
  nlp_score: number = 0;
  eid: string = "";
  isSaveInProgress: boolean = false;
  scroll: boolean = false;
  timeout?: any;
  isEditorLoaded: boolean = false;
  resetSettings = { body: { min: 0, max: 0 }, h2: { min: 0, max: 0 }, h3: { min: 0, max: 0 }, h46: { min: 0, max: 0 }, paragraph: { min: 0, max: 0 }, images: { min: 0, max: 0 } };
  isDebouncing: boolean = false;
  table: any;
  newInternalLinkArr: any;
  get className() {
    return !this.theme ? 'tag-menu' : ''
  }
  get menu() {
    return !this.theme ? 'providers-menu' : ''
  }

  get popover() {
    return !this.theme ? 'dark-popover ' : ''
  }
  uid: any = '';
  isTermHighlighted: boolean = false;
  isCountSet: boolean = false;
  isScrolled: boolean = false;
  scrollHeight: number = 0;
  termArray: any[] = [];
  internalLinkArr: any[] = []
  constructor(
    private themingService: ThemingService,
    private modal: NgbModal,
    public editorService: EditorService,
    public activatedRouter: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private cookieServ: CookieService,
    private router: Router,
    private toster: ToastrService,
    public _snackBar: MatSnackBar,
  ) {
    this.activatedRouter.params.subscribe(params => {
      this.eid = params['id'];
      this.themingService.setId(params['id']);
    });
    // Quill.register(TableBlockEmbed, true);
    this.uid = this.cookieServ.get("uid");
    // this.uid = "u-8842b392-d3ae-11ed-bbac-7738ed7ada70";
    this.userName = this.cookieServ.get("userName");
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res
    })

    icons['strike'] = '<img src="../../../assets/icons/Frame 134.svg" height="20" width="20" alt="">';
    icons['undo'] = '<svg viewbox="0 0 18 18"><polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>' +
      '<path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path></svg>';
    icons['redo'] = '<svg viewbox="0 0 18 18"><polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>' +
      '<path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path></svg>';
    icons['tables'] = '<svg viewbox="0 0 18 18"><polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>' +
      '<path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path></svg>';
  }

  ngOnInit(): void {
    this.themingService.pingThemeName()
    // this.themingService.nameKeeper.subscribe(val => { this.theme = val });
    this.loading = true;
    this.activatedRouter.params.subscribe(res => {
      if (!!res && res.id) {
        this.cid = res.id
        this.getEditorDatas('initialLoad');
        this.getInternalLinks();
        // this.highlightTerms();
      }
    });
    if (this.uid) {
      this.getIntreGretedAccount()
    }
  }
  getAiContent() {
    this.loading = true;

    this.getAiData('initial');
    setTimeout(() => {
      this.editorService.getSocketRes(this.eid).subscribe((ress: any) => {
        if (!ress.ai_running) {
          this.getAiData('')
        }
      });
    }, 500);


  }
  getAiData(arg: string) {
    this.editorService.getAiContent({
      "type": "generate_article",
      "editor_type": "editor",
      "id": this.eid
    }).subscribe(res => {
      if (arg === '' || arg === undefined) {
        const delta = this.quillEditor.clipboard.convert({ html: res.article });
        this.quillEditor.setContents(delta, 'silent');
        this.saveContent();
        this.getEditorDatas();
      }
    })
  }
  onScroll(event: any) {
    this.scroll = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.scroll = false;
    }, 300);
  }
  getIntreGretedAccount() {
    this.editorService.getIntregratedAccount({ uid: this.uid, type: "wordpress" }).subscribe((res) => {
      this.intregtedAccount = res.account
    })
  }

  async addContentInWordpress(index: any) {
    let _Obj = {
      password: this.intregtedAccount[index].appPassword,
      username: this.intregtedAccount[index].userName,
      website: this.intregtedAccount[index].webSite,
      title: this.titleField,
      content: document.getElementsByClassName("ql-editor")[0].innerHTML,
    }
    this.editorService.addContent(_Obj).subscribe((res: any) => {
      try {
        if (res.id) {
          this.toster.success('The article has been saved as a draft on your WordPress site.')
        } else if (res.message) {
          this.toster.error(res.message)
        } else if (res.status == 403) {
          this.toster.error('Please provide valid account details')
        } else if (res.status == 401) {
          this.toster.error('Sorry, you are not allowed to create posts as this user.')
        }
      } catch (error: any) {
        this.toster.error(error.message)
      }
      // this.intregtedAccount = res.data
    })
  }

  openMyMenu(menuTrigger: MatMenuTrigger) {
    menuTrigger.openMenu();
  }
  ngOnDestroy(): void {
    this.modal.dismissAll();
  }
  getEditorDatas(arg?: string) {
    if (!!arg && arg === 'noLoad') {
      this.loading = false;
    } else {
      this.loading = true;
    }
    this.editorService.getEditorData({ "cid": this.cid }).subscribe(response => {
      if (!!response) {
        this.nlp_score = response?.editor?.keywords?.length != 0 ? (response?.editor?.keywords?.reduce((a: any, b: any) => ({ occurance: a?.occurance + b?.occurance })).occurance / response?.editor?.keywords?.length) : 0;
        this.editorData = response;
        this.editorData['structure'] = this.structureObj;
        this.editorData['density'] = this.density;
        this.editorData['structureCharacters'] = this.characters;
        this.editorData['structureElements'] = this.elements;
        if (!!arg && arg === "initialLoad") {
          // this.html = response?.editor?.content;
          // this.getAiContent()
          this.quill.root.innerHTML = response?.editor?.content;
        }
        response.editor.keywords = response?.editor?.keywords.map((e: any) => {
          return { ...e, nlp: e.occurance > this.nlp_score ? true : false }
        }).sort((a: any, b: any) => {
          if (b.score > a.score) {
            return 1;
          } else if (a.score === undefined) {
            return 1;
          } else {
            return -1;
          }
        });
        this.checkObj = this.isEmpty(response.editor.term_ie);
        this.checkStrucutureObj = this.isEmpty(response.editor.structure_settings);

        if (!!this.checkObj) {
          response.editor.term_ie.inCludedTerms.mainContent = response.editor.term_ie.inCludedTerms.mainContent.sort((a: any, b: any) => {
            if (b.score > a.score) {
              return 1;
            } else {
              return -1;
            }
          });
          this.titleData = response.editor.term_ie.inCludedTerms.title.map((e: any) => { e.count = 0, e.type = "included"; return e });
          this.h1Data = response.editor.term_ie.inCludedTerms.h1.map((e: any) => { e.count = 0, e.type = "included"; return e });
          this.h2Data = response.editor.term_ie.inCludedTerms.h2.map((e: any) => { e.count = 0, e.type = "included"; return e });
          this.mainContentData = response.editor.term_ie.inCludedTerms.mainContent.map((e: any) => { e.count = 0, e.type = "included"; return e });
        } else {
          this.titleData = response.editor.keywords_title.map((e: any) => { e.count = 0, e.type = "included"; return e });
          this.h1Data = response.editor.keywords_h1.map((e: any) => { e.count = 0, e.type = "included"; return e });
          this.h2Data = response.editor.keywords_h2.map((e: any) => { e.count = 0, e.type = "included"; return e });
          this.mainContentData = response?.editor?.keywords.map((e: any) => { e.count = 0, e.type = "included"; return e });
        }
        // this.score = response.editor.content_score;
        // this.titleData = response.editor.keywords_title.map((e: any) => { e.count = 0; return e });
        // this.h1Data = response.editor.keywords_h1.map((e: any) => { e.count = 0; return e });
        // this.h2Data = response.editor.keywords_h2.map((e: any) => { e.count = 0; return e });
        this.titleField = response.editor.title;
        document.getElementById('highlight-title')!.innerText = response.editor.title
        this.metaField = response.editor.meta_desc;
        // this.mainContentData = response?.editor?.keywords.map((e: any) => { e.count = 0; return e });
        Object.values(this.editorData.editor.data).forEach((e: any) => {
          for (let key in e) {
            if (key === "brief") {
              e[key].h1.forEach((element: any) => {
                this.h1Brief.push(element)
              });
              e[key].h2.forEach((element: any) => {
                this.backupH2Brief.push(element);
                this.h2Brief.push(element)
              });
              e[key].h3.forEach((element: any) => {
                this.backupH3Brief.push(element);
                this.h3Brief.push(element)
              });
            }
          }
        });
        let slicedCompetitor = Object.values(this.editorData.editor.data);
        this.topCompititiorTitle = [...slicedCompetitor];
        this.allData = [...this.mainContentData, ...this.h1Data, ...this.h2Data, ...this.titleData];
        this.top3Data = this.allData.filter(el => {
          return el.top3 && el.top3 == true;
        });
        this.nlpData = this.mainContentData.filter(el => {
          return el.nlp === true;
        });
        this.termsSettings = [];

        if (!!this.checkObj) {
          let termsData = [...response.editor.term_ie.inCludedTerms.h1,
          ...response.editor.term_ie.inCludedTerms.h2,
          ...response.editor.term_ie.inCludedTerms.title,
          ...response.editor.term_ie.inCludedTerms.mainContent,
          ...response.editor.term_ie.excludedTerms.h1,
          ...response.editor.term_ie.excludedTerms.h2,
          ...response.editor.term_ie.excludedTerms.title,
          ...response.editor.term_ie.excludedTerms.mainContent,
          ...response.editor.term_ie.ignoredTerms.h1,
          ...response.editor.term_ie.ignoredTerms.h2,
          ...response.editor.term_ie.ignoredTerms.title,
          ...response.editor.term_ie.ignoredTerms.mainContent,
          ];
          termsData.forEach(e => {
            if (this.termsSettings.length == 0 || this.termsSettings.filter(t => e.keyword == t.keywordName).length == 0) {
              this.termsSettingsBackup.push(e);
              this.termsSettings.push(
                {
                  keywordName: e.keyword,
                  isH1: e.isH1,
                  isH2: e.isH2,
                  isTitle: e.isTitle,
                  isMainContent: e.isMainContent,
                  isSelected: false,
                  type: e.type
                }
              )
            }
          })
        }
        else {
          this.allData.forEach(e => {
            if (this.termsSettings.length == 0 || this.termsSettings.filter(t => e.keyword == t.keywordName).length == 0) {
              this.termsSettingsBackup.push(e);
              this.termsSettings.push(
                {
                  keywordName: e.keyword,
                  isH1: this.h1Data.some(el => el.keyword === e.keyword) ? true : false,
                  isH2: this.h2Data.some(el => el.keyword === e.keyword) ? true : false,
                  isTitle: this.titleData.some(el => el.keyword === e.keyword) ? true : false,
                  isMainContent: this.mainContentData.some(el => el.keyword === e.keyword) ? true : false,
                  isSelected: false,
                  type: "included"
                }
              )

            }
          });
        }
        let allBackupTermsSettings = [...this.editorData.editor?.keywords, ...this.editorData.editor?.keywords_h1, ...this.editorData.editor?.keywords_h2, ...this.editorData.editor?.keywords_title];
        allBackupTermsSettings.forEach(e => {
          if (this.backupTermsSettings.length == 0 || this.backupTermsSettings.filter(t => e.keyword == t.keywordName).length == 0) {
            this.backupTermsSettings.push(
              {
                keywordName: e.keyword,
                isH1: this.editorData.editor?.keywords_h1.some((el: any) => el.keyword === e.keyword) ? true : false,
                isH2: this.editorData.editor?.keywords_h2.some((el: any) => el.keyword === e.keyword) ? true : false,
                isTitle: this.editorData.editor?.keywords_title.some((el: any) => el.keyword === e.keyword) ? true : false,
                isMainContent: this.editorData.editor?.keywords.some((el: any) => el.keyword === e.keyword) ? true : false,
                isSelected: false,
                type: "included"
              }
            )

          }
        });
        this.checkOutline = this.isEmpty(response?.editor?.outline)
        this.checkBaseOutline = this.isEmpty(response.editor.baseOutline);
        if (!!this.checkBaseOutline) {
          this.baseOutlineData = JSON.parse(this.editorData?.editor?.baseOutline);
          this.baseOutlineData.forEach(e => {
            e.isEditable = true;
            e.isCheck = false;
          })
        }
        // this.allData.push(...this.top3Data);
        this.getMinmax();
        this.getDensity();
        this.debounce();
        // this.modifyBaseOutline();
        this.loading = false;
        this.isSaveInProgress = false;
      }

    })
  }
  isEmpty(obj: any) {
    if (Object.keys(obj).length === 0) {
      return false
    } else {
      return true;
    }
    ;
  }
  getDensity() {
    for (let key in this.editorData.editor.data) {
      if (!this.density[2].min || this.density[2].min > this.editorData?.editor?.data[key]?.body[this.editorData.editor.keyword]) {
        this.density[2].min = this.editorData?.editor?.data[key]?.body[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.body[this.editorData.editor.keyword] : 0;
      }
      if (!this.density[2].max || this.density[2].max < this.editorData?.editor?.data[key]?.body[this.editorData.editor.keyword]) {
        this.density[2].max = this.editorData?.editor?.data[key]?.body[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.body[this.editorData.editor.keyword] : 0;
      }
      for (let key1 in this.editorData?.editor?.data[key]?.p?.text) {
        let count = 0;
        this.editorData?.editor?.data[key]?.p?.text[key1]?.forEach((ele: any) => {
          if (ele.toLowerCase().includes(this.editorData.editor.keyword)) {
            count += 1;
          }
        });
        if (!this.density[3].min || this.density[3].min > count) {
          this.density[3].min = count;
        }
        if (!this.density[3].max || this.density[3].max < count) {
          this.density[3].max = count;
        }
      }
      for (let key2 in this.editorData?.editor?.data[key]?.h2?.kw) {
        let count = 0;
        this.editorData?.editor?.data[key]?.h2?.kw[key2]?.forEach((ele: any) => {
          if (ele.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
            count += 1;
          }
        });
        if (!this.density[4].min || this.density[4].min > count) {
          this.density[4].min = count;
        }
        if (!this.density[4].max || this.density[4].max < count) {
          this.density[4].max = count;
        }
      }
      for (let key3 in this.editorData?.editor?.data[key]?.h3?.kw) {
        let count = 0;
        this.editorData?.editor?.data[key]?.h3?.kw[key3]?.forEach((ele: any) => {
          if (ele.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
            count += 1;
          }
        });
        if (!this.density[5].min || this.density[5].min > count) {
          this.density[5].min = count;
        }
        if (!this.density[5].max || this.density[5].max < count) {
          this.density[5].max = count;
        }
      }
      for (let key4 in this.editorData?.editor?.data[key]?.h46) {
        let count = 0;
        this.editorData?.editor?.data[key]?.h46[key4]?.forEach((ele: any) => {
          if (ele.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
            count += 1;
          }
        });
        if (!this.density[6].min || this.density[6].min > count) {
          this.density[6].min = count;
        }
        if (!this.density[6].max || this.density[6].max < count) {
          this.density[6].max = count;
        }
      }
      for (let key5 in this.editorData?.editor?.data[key]?.b?.text) {
        let count = 0;
        this.editorData?.editor?.data[key]?.b?.text[key5]?.forEach((ele: any) => {
          if (ele.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
            count += 1;
          }
        });
        if (!this.density[7].min || this.density[7].min > count) {
          this.density[7].min = count;
        }
        if (!this.density[7].max || this.density[7].max < count) {
          this.density[7].max = count;
        }
      }
      // if (!this.density[4].min || this.density[4].min > this.editorData?.editor?.data[key]?.h2?.kw[this.editorData.editor.keyword]?.length) {
      //   this.density[4].min = this.editorData?.editor?.data[key]?.h2?.kw[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.h2?.kw[this.editorData.editor.keyword]?.length : 0;
      // }
      // if (!this.density[4].max || this.density[4].max < this.editorData?.editor?.data[key]?.h2?.kw[this.editorData.editor.keyword]?.length) {
      //   this.density[4].max = this.editorData?.editor?.data[key]?.h2?.kw[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.h2?.kw[this.editorData.editor.keyword]?.length : 0;
      // }
      // if (!this.density[5].min || this.density[5].min > this.editorData?.editor?.data[key]?.h3?.kw[this.editorData.editor.keyword]?.length) {
      //   this.density[5].min = this.editorData?.editor?.data[key]?.h3?.kw[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.h3?.kw[this.editorData.editor.keyword]?.length : 0;
      // }
      // if (!this.density[5].max || this.density[5].max < this.editorData?.editor?.data[key]?.h3?.kw[this.editorData.editor.keyword]?.length) {
      //   this.density[5].max = this.editorData?.editor?.data[key]?.h3?.kw[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.h3?.kw[this.editorData.editor.keyword]?.length : 0;
      // }
      // if (!this.density[6].min || this.density[6].min > this.editorData?.editor?.data[key]?.h46[this.editorData.editor.keyword]?.length) {
      //   this.density[6].min = this.editorData?.editor?.data[key]?.h46[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.h46[this.editorData.editor.keyword]?.length : 0;
      // }
      // if (!this.density[6].max || this.density[6].max < this.editorData?.editor?.data[key]?.h46[this.editorData.editor.keyword]?.length) {
      //   this.density[6].max = this.editorData?.editor?.data[key]?.h46[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.h46[this.editorData.editor.keyword]?.length : 0;
      // }
      // if (!this.density[7].min || this.density[7].min > this.editorData?.editor?.data[key]?.b?.text[this.editorData.editor.keyword]?.length) {
      //   this.density[7].min = this.editorData?.editor?.data[key]?.b?.text[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.b?.text[this.editorData.editor.keyword]?.length : 0;
      // }
      // if (!this.density[7].max || this.density[7].max < this.editorData?.editor?.data[key]?.b?.text[this.editorData.editor.keyword]?.length) {
      //   this.density[7].max = this.editorData?.editor?.data[key]?.b?.text[this.editorData.editor.keyword] ? this.editorData?.editor?.data[key]?.b?.text[this.editorData.editor.keyword]?.length : 0;
      // }
    }
  }

  transformHtml(htmlTextWithStyle: any): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
  }
  // onPaste(){
  //   this.isScrolled = true;
  //   this.scrollHeight = document.getElementsByClassName('editor-wrapper')[0].scrollTop;
  // }


  ngAfterViewInit() {
    setTimeout(() => {
      let self = this;
      self.quill = new Quill('#editor', {
        theme: 'snow',
        modules: {
          toolbar: {
            container: "#toolbar",
            handlers: {
              tables: this.tableOperations
            }

          },
          table: true,
          blotFormatter: {
            // empty object for default behaviour.
          },

          history: {
            delay: 100,
            maxStack: 500,
            userOnly: true
          }
        },
        // scrollingContainer: '.editor-wrapper',
        placeholder: this.uid ? "Start writing your content" : '',
      });
      let quilll = this.quillEditor !== undefined ? this.quillEditor : this.quill
      this.table = quilll?.getModule('table');
      // self.quill.clipboard.addMatcher('TABLE', (node: any, delta: any) => {
      //   const Delta = Quill.import('delta');
      //   const tableTagStyles = node.getAttribute('style');
      //   // return new Delta([
      //   //   {
      //   //     insert: {
      //   //       TableBlockEmbed:
      //   //         `<style>#tableId {${tableTagStyles} margin: 0 auto !important; }</style>` + delta.ops[0].insert.TableBlockEmbed
      //   //     }
      //   //   }
      //   // ]);
      // });
      this.quillEditor = self.quill;
      self.quill.on('selection-change', (range: any, oldRange: any, source: any) => {
        if (range === null && oldRange !== null) {
          // self.quill?.blur();
          self.quillEditor?.blur();
        } else {
          let toolbar = (document.getElementById('floater') as any);
          let tooltip = (document.getElementById('custom-tooltip') as any);
          toolbar.style.display = "none";
          tooltip.style.display = "none"
          const deltaa = self.quillEditor.getFormat();
          if (Object.keys(deltaa).length > 0) {
            for (let key in deltaa) {
              if (key === 'table') {
                this.isTable = true;
              } else {
                this.isTable = false;
              }
            }
          } else {
            this.isTable = false;
          }
        }
      });
      self.quill.on('text-change', function (event: any) {
        self.isDebouncing = true;
        const deltaa = self.quillEditor.getFormat();
        if (Object.keys(deltaa).length > 0) {
          for (let key in deltaa) {
            if (key === 'table') {
              self.isTable = true;
            } else {
              self.isTable = false;
            }
          }
        } else {
          self.isTable = false;
        }
        // if(!!self.isTermHighlighted){
        //   self.highlightMaster();
        // }
        self.textChangeCount += 1;
        if (self.timeoutId) {
          clearTimeout(self.timeoutId);
        }
        self.timeoutId = setTimeout(() => {
          let innerHtml = (document.getElementsByClassName('ql-editor')[0] as any).innerHTML;
          document.getElementById('highlight-div')!.innerHTML = innerHtml;
          self.isDebouncing = false;
          self.debounce();
          self.saveContent();
          self.quill?.getSelection();
        }, 1000);
      });

      if (!this.uid) {
        self.quill.disable();
      }
      this.isEditorLoaded = true;
    }, 100);

  }

  debounce(arg?: string) {
    this.processBase();
    this.scoreCount();
    // let innerHtml = (document.getElementsByClassName('ql-editor')[0] as any).innerHTML;
    // document.getElementById('highlight-div')!.innerHTML = innerHtml;

    // this.highlightTerms();

    this.highlightMaster();
    // this.createInternalLink();
  }
  tableOperations(args: any) {
    let quilll = this.quillEditor !== undefined ? this.quillEditor : this.quill
    this.table = quilll.getModule('table');

    switch (args.target && args.target.value ? args.target.value : args) {
      case "1":
        this.table.insertTable(2, 2)
        break;
      case "2":
        this.table.insertRowAbove()
        break;
      case "3":
        this.table.insertRowBelow()
        break;
      case "4":
        this.table.insertColumnLeft()
        break;
      case "5":
        this.table.insertColumnRight()
        break;
      case "6":
        this.table.deleteRow()
        break;
      case "7":
        this.table.deleteColumn()
        break;
      case "8":
        this.table.deleteTable()
        break;
      default:
        break;
    }
    let toolbar = (document.getElementById('floater') as any);
    toolbar.style.display = "none"
    this.processBase();
  }
  editorCreated(event: any) {
    this.quillEditor = event;
  }
  triggerundo() {
    // this.undoCount +=1;
    if (this.textChangeCount === 1) {
      this.quillEditor.history.quill.history.clear();
    } else {
      this.quillEditor.history.quill.history.undo();
    }
    // document.execCommand('undo', false, null);
    // this.quillEditor?.history.undo();
  }
  triggerredo() {

    // this.quillEditor.history.quill.history.redo();
    this.quillEditor.history.redo();
  }
  processBase() {
    let self = this;
    let _data: any = document.getElementsByClassName("ql-editor")[0];
    let tag_editor: any = document.getElementById('tag-editorr');
    tag_editor.innerHTML === null ? tag_editor.innerHTML = "" : tag_editor.innerHTML = "";
    _data?.childNodes?.forEach((e: any) => {
      if (_data.childNodes.length == 1 && _data.childNodes[0].outerHTML === "<p><br></p>") {
        _data.childNodes[0].outerHTML = '<h1><br></h1><p></p>';

      }
      let div = document.createElement(e.tagName);
      let span = document.createElement('span');
      div.style.display = "flex";
      div.style.alignItems = "center";
      div.style.justifyContent = "center";
      div.style.paddingRight = "30px";
      div.style.color = "#8080806e";

      // div.style.borderRadius = "6px";

      if (e.tagName === "BLOCKQUOTE") {
        div.innerHTML = "";
        div.style.marginBottom = "0";
      } else if (e.tagName === "TABLE") {
        div.innerHTML = "TBL";
        div.style.marginBottom = "0";
      } else {
        div.innerHTML = e.tagName;
      }
      let mt = window.getComputedStyle(e).marginTop;
      let mb = window.getComputedStyle(e).marginBottom;
      let divColor = this.getTagColors(div.innerHTML)
      div.style.height = e?.getBoundingClientRect()?.height + 'px';
      div.style.borderRight = "7px solid " + divColor;
      div.style.marginTop = mt;
      div.style.marginBottom = mb
      tag_editor.appendChild(div);
    })
    let _title = this.titleField;
    let _meta = this.metaField;
    let _datum: any = {};
    let _ExactDesnsity: any = {}
    _datum.h1 = Object.values(_data.getElementsByTagName("h1")).map((x: any) => x.innerText);
    _datum.h2 = Object.values(_data?.getElementsByTagName("h2"))?.map((x: any) => x.innerText);
    _datum.h3 = Object.values(_data?.getElementsByTagName("h3"))?.map((x: any) => x.innerText);
    _datum.h4 = Object.values(_data?.getElementsByTagName("h4"))?.map((x: any) => x.innerText);
    _datum.h5 = Object.values(_data?.getElementsByTagName("h5"))?.map((x: any) => x.innerText);
    _datum.h6 = Object.values(_data?.getElementsByTagName("h6"))?.map((x: any) => x.innerText);
    _datum.p = Object.values(_data?.getElementsByTagName("p"))?.map((x: any) => x.innerText.replace('\n', ''));
    _datum.a = Object.values(_data?.getElementsByTagName("a"))?.map((x: any) => x.innerText);
    _datum.ahref = Object.values(_data.getElementsByTagName("a")).map((x: any) => x.href);
    _datum.img = Object.values(_data.getElementsByTagName("img")).map((x: any) => x.alt);
    _datum.b = Object.values(_data.getElementsByTagName("b")).map((x: any) => x.innerText);
    _datum.b = _datum.b.concat(Object.values(_data.getElementsByTagName("strong")).map((x: any) => x.innerText));
    _datum.title = [_title];
    _datum.meta_desc = [_meta];
    let _base: any = {
      "a": { count: 0, ahref: [] },
      "h1": { count: 0, text: [], kw: {} }, // text list of text, kw dict of keyword used keyword: [list of elements text]
      "h2": { count: 0, text: [], kw: {} },
      "h3": { count: 0, kw: {} },
      "h4": { count: 0 },
      "h5": { count: 0 },
      "h6": { count: 0 },
      "h46": {}, // dict of keyword used
      "b": { count: 0, text: {} },
      "p": { count: 0, text: {} },
      "img": { count: 0, text: {} },
      "title": { count: 0, text: [], kw: {} },
      "body": {},// keyword: kw count
      "url": "#baseurl",
      "meta_description": [], // list of element text
      "meta_keywords": [],
      "meta_robots": [],
      "word_len": {},
      "first150": {},
      "position": 0,
    };
    _base.word_len = {
      "a": _datum.a.map((x: any) => x.split(" ").length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "b": _datum.b.map((x: any) => x.split(" ").length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "p": _datum.p.map((x: any) => x.split(" ").filter((e: any) => e !== '').length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "h1": _datum.h1.map((x: any) => x.split(" ").filter((e: any) => e !== '').length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "h2": _datum.h2.map((x: any) => x.split(" ").filter((e: any) => e !== '').length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "h3": _datum.h3.map((x: any) => x.split(" ").filter((e: any) => e !== '').length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "h4": _datum.h4.map((x: any) => x.split(" ").filter((e: any) => e !== '').length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "h5": _datum.h5.map((x: any) => x.split(" ").filter((e: any) => e !== '').length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "h6": _datum.h6.map((x: any) => x.split(" ").filter((e: any) => e !== '').length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "img": _datum.img.map((x: any) => x.split(" ").length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "title": _datum.title.map((x: any) => x.split(" ").filter((e: any) => e !== '').length).reduce((partial_sum: any, x: any) => partial_sum + x, 0),
      "body": _data.innerText.replace('\n', '') == "" ? 0 : (_data.innerText.replaceAll(/||enter||/g, '').replaceAll('\n', ' ').replaceAll('||enter||', ' ').split(" ").filter((x: any) => {
        return x != "" && x != " " && x != "||enter||"
      }).length),
    };
    if (_title == "") _base.word_len.title = 0;
    _base.word_len.h46 = _base.word_len.h4 + _base.word_len.h5 + _base.word_len.h6;
    _base.a.count = _datum.a.length;
    _base.h1.count = _datum.h1.length;
    _base.h2.count = _datum.h2.length;
    _base.h3.count = _datum.h3.length;
    _base.h4.count = _datum.h4.length;
    _base.h5.count = _datum.h5.length;
    _base.h6.count = _datum.h6.length;
    _base.b.count = _datum.b.length;
    _base.p.count = _datum.p.length;
    _base.img.count = _datum.img.length;
    _base.title.count = _datum.title;
    _base.a.ahref = _datum.ahref;
    let text: any = { h1: {}, h2: {}, h3: {}, h46: {}, b: {}, p: {}, img: {}, title: {} };
    let count: any = { first100: {}, body: {} }
    _base.h1.kw = text.h1;
    _base.h1.text = _datum.h1;
    _base.h2.kw = text.h2;
    _base.h2.text = _datum.h2;
    _base.title.kw = text.title;
    _base.title.text = _datum.title;
    _base.meta_description = _datum.meta_desc;
    _base.h3.kw = text.h3;
    _base.b.text = text.b;
    _base.p.text = text.p;
    _base.img.text = text.img;
    _base.body = count.body;
    self.base = _base;
    this.editorData?.structure?.forEach((keyname: any) => {
      if (keyname.key === "Body") {
        keyname.latestCount = self.base.word_len.body;
      }
      if (keyname.key === "Paragraph") {
        keyname.latestCount = self.base.word_len.p;
      }
      if (keyname.key === "Title") {
        // let title = this.titleField.split(" ").filter((element: any) => element);
        keyname.latestCount = self.base.word_len.title;
      }
      if (keyname.key === "H2") {
        keyname.latestCount = self.base.word_len.h2;
      }
      if (keyname.key === "H3") {
        keyname.latestCount = self.base.word_len.h3;
      }
      if (keyname.key === "H4-H6") {
        keyname.latestCount = self.base.word_len.h46;
      }
      if (keyname.key === "Bold/B") {
        keyname.latestCount = self.base.word_len.b;
      }
      keyname['percent'] = ((keyname.latestCount) * 100) / (keyname.max)
    });
    this.editorData.structureElements.forEach((keyname: any) => {
      if (keyname.key === "H1") {
        keyname.latestElementCount = self.base.h1.count;
      }
      if (keyname.key === "H2") {
        keyname.latestElementCount = self.base.h2.count;
      }
      if (keyname.key === "H3") {
        keyname.latestElementCount = self.base.h3.count;
      }
      if (keyname.key === "H4-H6") {
        keyname.latestElementCount = self.base.h4.count + self.base.h5.count + self.base.h6.count
      }
      if (keyname.key === "Paragraph") {
        keyname.latestElementCount = self.base.p.count
      }
      if (keyname.key === "Strong/B") {
        keyname.latestElementCount = self.base.b.count;
      }
      if (keyname.key === "Image") {
        keyname.latestElementCount = self.base.img.count;
      }
      keyname['percent'] = ((keyname.latestElementCount) * 100) / (keyname.max)
    });
    let bcount = 0;
    let titleCount = 0;
    let bodyCount = 0;
    let h3Count = 0;
    let pCount = 0;
    let h46Count = 0;
    this.density[7].latestCount = 0;
    this.density[6].latestCount = 0;
    this.density[5].latestCount = 0;
    this.density[3].latestCount = 0;
    this.density[0].latestCount = 0;
    _datum.b.forEach((e: any) => {
      if (e.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
        bcount += 1;
        this.density[7].latestCount = bcount;
      }
    });
    _datum.title.forEach((e: any) => {
      if (e.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
        titleCount += 1;
        this.density[0].latestCount = titleCount;
      }
    });
    _datum.p.forEach((e: any) => {
      if (e.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
        pCount += 1;
        this.density[3].latestCount = pCount;
      }
    });
    _datum.h3.forEach((e: any) => {
      if (e.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
        h3Count += 1;
        this.density[5].latestCount = h3Count;
      }
    });
    _datum.h4.forEach((e: any) => {
      if (e.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
        h46Count += 1;
        this.density[6].latestCount = h46Count;
      }
    });
    _datum.h5.forEach((e: any) => {
      if (e.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
        h46Count += 1;
        this.density[6].latestCount = h46Count;
      }
    });
    _datum.h6.forEach((e: any) => {
      if (e.toLowerCase().includes(this.editorData.editor.keyword.toLowerCase())) {
        h46Count += 1;
        this.density[6].latestCount = h46Count;
      }
    })
    this.editorData.structureCharacters[0].latestWordCount = this.titleField.replace(/\s/g, '').length;
    this.editorData.structureCharacters[0]['percent'] = ((this.editorData.structureCharacters[0].latestWordCount) * 100) / (this.editorData.structureCharacters[0].max);
    this.editorData.structureCharacters[1].latestWordCount = this.metaField.replace(/\s/g, '').length;
    this.editorData.structureCharacters[1]['percent'] = ((this.editorData.structureCharacters[1].latestWordCount) * 100) / (this.editorData.structureCharacters[1].max);
    // console.log(this.baseOutlineData,"tttttttttt")
    this.calculateAiStructure();
    const htmlTexEditor = toDoc(_data.innerHTML);
    this.getTagCount(htmlTexEditor);
  }
  calculateAiStructure() {
    let structure: any = {};
    structure['keywords'] = {};
    structure['briefs'] = {};
    structure['no of words'] = this.editorData.structure.filter((ell: any) => { if (ell.key == "Body" || ell.key == "Paragraph") { return ell } }).map((el: any) => { return { key: el.key, min: el.min, max: el.max } });;
    structure['no of elements'] = this.editorData.structureElements.filter((ell: any) => { if (ell.key == "H2" || ell.key == "H3" || ell.key == "Paragraph") { return ell } }).map((el: any) => { return { key: el.key, min: el.min, max: el.max } });
    // structure['characters'] = this.editorData.structureCharacters;
    // structure['density'] = this.editorData.density;
    structure['keywords']['title'] = this.titleData.map((el: any) => { return { key: el.keyword, min: el.min, max: el.max } });
    structure['keywords']['h1'] = this.h1Data.map((el: any) => { return { key: el.keyword, min: el.min, max: el.max } });;
    structure['keywords']['h2'] = this.h2Data.map((el: any) => { return { key: el.keyword, min: el.min, max: el.max } });;
    structure['keywords']['mainContent'] = this.mainContentData.map((el: any) => { return { key: el.keyword, min: el.min, max: el.max } });;
    structure['keywords']['nlp'] = this.nlpData.map((el: any) => { return { key: el.keyword, min: el.min, max: el.max } });;

    let checkBriefArr: any = [];
    let dataaa = this.editorData?.editor?.outline?.filter((e: any, index: any) => {
      if (this.editorData?.editor?.competitors?.includes(index.toString())) {
        checkBriefArr.push({ link: e.link, compititor: index });
        e['compititor'] = index
        return e;
      }
    }).map((el: any) => {
      el?.outline?.forEach((ell: any) => {
        ell.compititor = el.compititor
      });
      return { ...el.outline }
    });
    let arr: any = [];
    dataaa.forEach((el: any) => {
      for (let key in el) {
        arr.push(el[key])
      }
    })
    structure['outline'] = arr.map((arr: any) => { delete arr.level; return { ...arr } });
    structure['briefs']['h2Briefs'] = this.h2Brief.filter((ell: any) => {
      let checkAvailable = checkBriefArr.find((e: any) => { return e.link === ell.url })
      if (checkAvailable !== undefined) {
        ell['compititor'] = checkAvailable.compititor
        return ell
      }
    }
    ).map((el: any) => { return { title: el.title, type: el.type, body: el.body, compititor: el.compititor } });;
    structure['briefs']['h3Briefs'] = this.h3Brief.filter((ell: any) => {
      let checkAvailable = checkBriefArr.find((e: any) => { return e.link === ell.url })
      if (checkAvailable !== undefined) {
        ell['compititor'] = checkAvailable.compititor
        return ell
      }
    }).map((el: any) => { return { title: el.title, type: el.type, body: el.body, compititor: el.compititor } });
    console.log(structure, "eeee")

  }
  getHtmlTags() {
    setTimeout(() => {
      let _data: any = document.getElementsByClassName("ql-editor")[0];
      let tag_editor: any = document.getElementById('tag-editorr');
      tag_editor.innerHTML === null ? tag_editor.innerHTML = "" : tag_editor.innerHTML = "";
      _data?.childNodes?.forEach((e: any) => {
        if (_data.childNodes.length == 1 && _data.childNodes[0].outerHTML === "<p><br></p>") {
          _data.childNodes[0].outerHTML = '<h1><br></h1>'
        }
        let div = document.createElement(e.tagName);
        let span = document.createElement('span');
        div.style.display = "flex";
        div.style.alignItems = "center";
        div.style.justifyContent = "center";
        div.style.paddingRight = "30px";
        div.style.color = "#8080806e";

        // div.style.borderRadius = "6px";

        // if (e.tagName === "BLOCKQUOTE" || e.tagName === "UL") {
        //   div.innerHTML = "";
        //   div.style.marginBottom = "0";
        // } else {
        //   div.innerHTML = e.tagName;
        // }
        if (e.tagName === "BLOCKQUOTE") {
          div.innerHTML = "";
          div.style.marginBottom = "0";
        } else if (e.tagName === "TABLE") {
          div.innerHTML = "TBL";
          div.style.marginBottom = "0";
        } else {
          div.innerHTML = e.tagName;
        }
        let mt = window.getComputedStyle(e).marginTop;
        let mb = window.getComputedStyle(e).marginBottom;
        let divColor = this.getTagColors(div.innerHTML)
        div.style.height = e?.getBoundingClientRect()?.height + 'px';
        div.style.borderRight = "7px solid " + divColor;
        div.style.marginTop = mt;
        div.style.marginBottom = mb
        tag_editor.appendChild(div);
      })
    }, 450);

  }
  getTagColors(tag: string) {
    let color
    switch (tag) {
      case 'H1':
        color = '#088395'
        break;
      case 'H2':
        color = '#acddde'
        break;
      case 'H3':
        color = '#F2F7A1'
        break;
      case 'H4':
        color = '#fef8dd'
        break;
      case 'H5':
        color = '#ffe7c7'
        break;
      case 'H6':
        color = '#f7d8ba'
        break;
      case 'P':
        color = '#D8F0C5'
        break;
      case 'UL':
        color = '#D8F0C5'
        break;
      case 'OL':
        color = '#D8F0C5'
        break;
      case 'TBL':
        color = 'rgb(255 92 117 / 59%)'
        break;
      default:
        color = 'transparent'
        break;
    }
    return color
  }
  countOccurrences(string: any, subString?: any, allowOverlapping?: any) {
    string += "";
    subString += "";
    string = string.toLowerCase();
    subString = subString.toLowerCase();
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = string.indexOf(subString, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  }
  scoreCount() {
    // this.score = 0;
    let score = 0;
    let elements: any = document.getElementsByClassName("ql-editor")[0];
    let h1Elements = elements.querySelectorAll('h1');
    let h2Elements = elements.querySelectorAll('h2');
    let h3Elements = elements.querySelectorAll('h3');
    let pElements = elements.querySelectorAll('p');
    let checkH1 = Array.from(h1Elements).some((el: any) => {
      return el.innerText.toLocaleLowerCase().includes(this.editorData.editor.keyword.toLocaleLowerCase())
    });
    let checkH2 = Array.from(h2Elements).some((el: any) => {
      return el.innerText.toLocaleLowerCase().includes(this.editorData.editor.keyword.toLocaleLowerCase())
    });
    let checkH3 = Array.from(h3Elements).some((el: any) => {
      return el.innerText.toLocaleLowerCase().includes(this.editorData.editor.keyword.toLocaleLowerCase())
    });
    let checkP = Array.from(pElements).some((el: any) => {
      return el.innerText.toLocaleLowerCase().includes(this.editorData.editor.keyword.toLocaleLowerCase())
    });
    if (!!checkH1) {
      score += 8;
    }
    if (!!checkH2) {
      score += 2;
    }
    if (!!checkP) {
      score += 2;
    }
    if (!!checkH3) {
      score += 1;
    }
    if (this.titleField !== '' && this.titleField.toLocaleLowerCase().includes(this.editorData.editor.keyword.toLocaleLowerCase())) {
      score += 7;
    }
    if (this.editorData.structure[1]?.latestCount !== 0 && this.editorData.structure[1]?.latestCount >= this.editorData.structure[1]?.min && this.editorData.structure[1]?.latestCount <= this.editorData.structure[1]?.max) {
      score += 12;
    }
    let h2Score = this.h2Data.filter(e => { return e.count > 0 });
    if (h2Score.length > 0) {
      score += (h2Score.length * 15) / this.h2Data.length
    }
    let h2mainContentScore = this.mainContentData.filter(e => { return e.count > 0 });
    if (h2mainContentScore.length > 0) {
      let temp = h2mainContentScore.length / this.mainContentData.length * 100;
      score += temp > 50 ? 50 : temp
      // score += h2mainContentScore.length / this.mainContentData.length * 50
    }
    if (this.editorData.structureElements[5].latestElementCount > 0) {
      score += 1
    }
    if (this.editorData.structureElements[4].latestElementCount > 0) {
      score += 2
    }
    // if (score > 20 && score < 20) {
    //   let remainingScore = 100 - score;
    //   let additionalScore = remainingScore / 4
    //   this.score = score + additionalScore;
    // } else {
    this.score = score;
    // }

  }

  drop(event: CdkDragDrop<any>) {
    moveItemInArray(this.sidebarArray, event.previousIndex, event.currentIndex);
  }
  // ngOnDestroy(): void {
  //   this.editor.destroy();
  // }
  getMinmax() {
    let data: any = []
    this.Object.values(this.editorData.editor.data).forEach((e: any) => {
      if (!!this.editorData.editor.competitors.includes(e.position.toString())) {
        data.push(e);
      }
    });
    data.forEach((element: any) => {
      let h46Count = 0;
      h46Count = element.h4.count + element.h5.count + element.h6.count;
      if (!!this.checkStrucutureObj) {
        this.editorData.structureElements[3].min = this.editorData.editor?.structure_settings.h46.min;
        this.editorData.structureElements[3].max = this.editorData.editor?.structure_settings.h46.max;
      } else {
        if (!this.editorData.structureElements[3].min || this.editorData.structureElements[3].min > h46Count) {
          this.editorData.structureElements[3].min = h46Count
        }
        if (!this.editorData.structureElements[3].max || this.editorData.structureElements[3].max < h46Count) {
          this.editorData.structureElements[3].max = h46Count
        }
      }
      for (let key in element) {
        if (key === "word_len") {
          if (!!this.checkStrucutureObj) {
            this.editorData.structure[0].min = this.editorData.editor.structure_settings.bodyLength.min;
            this.editorData.structure[0].max = this.editorData.editor.structure_settings.bodyLength.max;
          } else {
            if (!this.editorData.structure[0].min || this.editorData.structure[0].min > element.word_len.body) {
              this.editorData.structure[0].min = element.word_len.body;
            }
            if (!this.editorData.structure[0].max || this.editorData.structure[0].max < element.word_len.body) {
              this.editorData.structure[0].max = element.word_len.body;
            }
          }
          if (!this.editorData.structure[1].min || this.editorData.structure[1].min > element.word_len.p) {
            this.editorData.structure[1].min = element.word_len.p;
          }

          if (!this.editorData.structure[1].max || this.editorData.structure[1].max < element.word_len.p) {
            this.editorData.structure[1].max = element.word_len.p;
          }
          if (!this.editorData.structure[2].min || this.editorData.structure[2].min > element.word_len.title) {
            this.editorData.structure[2].min = element.word_len.title;
          }

          if (!this.editorData.structure[2].max || this.editorData.structure[2].max < element.word_len.title) {
            this.editorData.structure[2].max = element.word_len.title;
          }
          if (!this.editorData.structure[3].min || this.editorData.structure[3].min > element.word_len.h2) {
            this.editorData.structure[3].min = element.word_len.h2;
          }

          if (!this.editorData.structure[3].max || this.editorData.structure[3].max < element.word_len.h2) {
            this.editorData.structure[3].max = element.word_len.h2;
          }
          if (!this.editorData.structure[4].min || this.editorData.structure[4].min > element.word_len.h3) {
            this.editorData.structure[4].min = element.word_len.h3;
          }

          if (!this.editorData.structure[4].max || this.editorData.structure[4].max < element.word_len.h3) {
            this.editorData.structure[4].max = element.word_len.h3;
          }
          if (!this.editorData.structure[5].min || this.editorData.structure[5].min > element.word_len.h46) {
            this.editorData.structure[5].min = element.word_len.h46;
          }

          if (!this.editorData.structure[5].max || this.editorData.structure[5].max < element.word_len.h46) {
            this.editorData.structure[5].max = element.word_len.h46;
          }
          if (!this.editorData.structure[6].min || this.editorData.structure[6].min > element.word_len.b) {
            this.editorData.structure[6].min = element.word_len.b;
          }

          if (!this.editorData.structure[6].max || this.editorData.structure[6].max < element.word_len.b) {
            this.editorData.structure[6].max = element.word_len.b;
          }
          if (!this.editorData.structureCharacters[0].min || this.editorData.structureCharacters[0].min > element.word_len.title) {
            this.editorData.structureCharacters[0].min = element.word_len.title
          }
          if (!this.editorData.structureCharacters[0].max || this.editorData.structureCharacters[0].max < element.word_len.title) {
            this.editorData.structureCharacters[0].max = element.word_len.title
          }
        }
        if (key === "b") {
          if (!this.editorData.structureElements[5].min || this.editorData.structureElements[5].min > element[key].count) {
            this.editorData.structureElements[5].min = element[key].count
          }
          if (!this.editorData.structureElements[5].max || this.editorData.structureElements[5].max < element[key].count) {
            this.editorData.structureElements[5].max = element[key].count
          }
        }
        if (key === "p") {
          if (!!this.checkStrucutureObj) {
            this.editorData.structureElements[4].min = this.editorData.editor.structure_settings.paragraphLength.min;
            this.editorData.structureElements[4].max = this.editorData.editor.structure_settings.paragraphLength.max;
          } else {
            if (!this.editorData.structureElements[4].min || this.editorData.structureElements[4].min > element[key].count) {
              this.editorData.structureElements[4].min = element[key].count
            }
            if (!this.editorData.structureElements[4].max || this.editorData.structureElements[4].max < element[key].count) {
              this.editorData.structureElements[4].max = element[key].count
            }
          }
        }
        if (key === "h2") {
          if (!!this.checkStrucutureObj) {
            this.editorData.structureElements[1].min = this.editorData.editor.structure_settings.h2.min;
            this.editorData.structureElements[1].max = this.editorData.editor.structure_settings.h2.max;
          } else {
            if (!this.editorData.structureElements[1].min || this.editorData.structureElements[1].min > element[key].count) {
              this.editorData.structureElements[1].min = element[key].count
            }
            if (!this.editorData.structureElements[1].max || this.editorData.structureElements[1].max < element[key].count) {
              this.editorData.structureElements[1].max = element[key].count
            }
          }
        }
        if (key === "h3") {
          if (!!this.checkStrucutureObj) {
            this.editorData.structureElements[2].min = this.editorData.editor.structure_settings.h3.min;
            this.editorData.structureElements[2].max = this.editorData.editor.structure_settings.h3.max;
          } else {
            if (!this.editorData.structureElements[2].min || this.editorData.structureElements[2].min > element[key].count) {
              this.editorData.structureElements[2].min = element[key].count
            }
            if (!this.editorData.structureElements[2].max || this.editorData.structureElements[2].max < element[key].count) {
              this.editorData.structureElements[2].max = element[key].count
            }
          }
        }
        if (key === "img") {
          if (!!this.checkStrucutureObj) {
            this.editorData.structureElements[6].min = this.editorData.editor.structure_settings.imageLength.min;
            this.editorData.structureElements[6].max = this.editorData.editor.structure_settings.imageLength.max;
          } else {
            if (!this.editorData.structureElements[6].min || this.editorData.structureElements[6].min > element[key].count) {
              this.editorData.structureElements[6].min = element[key].count
            }
            if (!this.editorData.structureElements[6].max || this.editorData.structureElements[6].max < element[key].count) {
              this.editorData.structureElements[6].max = element[key].count
            }
          }

        }
        if (!this.resetSettings.h46.min || this.resetSettings.h46.min > h46Count) {
          this.resetSettings.h46.min = h46Count
        }
        if (!this.resetSettings.h46.max || this.resetSettings.h46.max < h46Count) {
          this.resetSettings.h46.max = h46Count
        }
        if (key === 'h2') {
          if (!this.resetSettings.h2.min || this.resetSettings.h2.min > element[key].count) {
            this.resetSettings.h2.min = element[key].count
          }
          if (!this.resetSettings.h2.max || this.resetSettings.h2.max < element[key].count) {
            this.resetSettings.h2.max = element[key].count
          }
        }
        if (key === 'h3') {
          if (!this.resetSettings.h3.min || this.resetSettings.h3.min > element[key].count) {
            this.resetSettings.h3.min = element[key].count
          }
          if (!this.resetSettings.h3.max || this.resetSettings.h3.max < element[key].count) {
            this.resetSettings.h3.max = element[key].count
          }
        }
        if (key === "img") {
          if (!this.resetSettings.images.min || this.resetSettings.images.min > element[key].count) {
            this.resetSettings.images.min = element[key].count
          }
          if (!this.resetSettings.images.max || this.resetSettings.images.max < element[key].count) {
            this.resetSettings.images.max = element[key].count
          }
        }
        if (key === 'p') {
          if (!this.resetSettings.paragraph.min || this.resetSettings.paragraph.min > element[key].count) {
            this.resetSettings.paragraph.min = element[key].count
          }
          if (!this.resetSettings.paragraph.max || this.resetSettings.paragraph.max < element[key].count) {
            this.resetSettings.paragraph.max = element[key].count
          }
        }
        if (!this.resetSettings.body.min || this.resetSettings.body.min > element.word_len.body) {
          this.resetSettings.body.min = element.word_len.body;
        }
        if (!this.resetSettings.body.max || this.resetSettings.body.max < element.word_len.body) {
          this.resetSettings.body.max = element.word_len.body;
        }
      }
    });
  }

  openModal(title: any, keyword?: any) {
    const modalRef = this.modal.open(ModalComponent, { centered: true, windowClass: !this.theme ? 'dark-modal custom-modal' : 'custom-modal' });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.keyword = keyword;
    modalRef.componentInstance.note = this.editorData?.editor?.note;
    modalRef.componentInstance.competitorList = this.editorData.editor.data;
    modalRef.componentInstance.defaultCompetitor = this.editorData.editor.competitors_default;
    modalRef.componentInstance.competitors = this.editorData.editor.competitors;
    modalRef.componentInstance.termsSettings = this.termsSettings;
    modalRef.componentInstance.termsSettingsBackup = this.backupTermsSettings;
    modalRef.componentInstance.theme = this.theme;
    let body = { max: JSON.stringify(this.editorData.structure[0].max), min: JSON.stringify(this.editorData.structure[0].min) };
    let h2 = { max: JSON.stringify(this.editorData.structureElements[1].max), min: JSON.stringify(this.editorData.structureElements[1].min) };
    let h3 = { max: JSON.stringify(this.editorData.structureElements[2].max), min: JSON.stringify(this.editorData.structureElements[2].min) };
    let h46 = { max: JSON.stringify(this.editorData.structureElements[3].max), min: JSON.stringify(this.editorData.structureElements[3].min) };

    let paragraph = { max: JSON.stringify(this.editorData.structureElements[4].max), min: JSON.stringify(this.editorData.structureElements[4].min) };
    let images = { max: JSON.stringify(this.editorData.structureElements[6].max), min: JSON.stringify(this.editorData.structureElements[6].min) };

    modalRef.componentInstance.structureSettings = { body: body, h2: h2, h3: h3, h46: h46, paragraph: paragraph, images: images };
    modalRef.componentInstance.resetSettings = this.resetSettings;
    if (title && this.uid) {
      modalRef.result.then(e => {
        this.loading = true
        if (title === "ContentStructure") {
          this.editorService.saveStructure({ cid: this.cid, structure_settings: { bodyLength: e.body, paragraphLength: e.paragraph, imageLength: e.image, h2: e.h2, h3: e.h3, h46: e.h46 } })
            .subscribe(res => {
              this.toster.success("Content Structure Settings Saved");
              this.getEditorDatas();
            })
        }
        if (title === "CompetitorSetting") {
          this.editorService.applyCompititors({ cid: this.cid, competitors: e.arr }).subscribe(res => {
            this.toster.success("Competitors Updated");
            this.structureObj = [
              { key: "Body", latestCount: 0, min: null, max: null },
              { key: "Paragraph", latestCount: 0, min: null, max: null },
              { key: "Title", latestCount: 0, min: null, max: null },
              { key: "H2", latestCount: 0, min: null, max: null },
              { key: "H3", latestCount: 0, min: null, max: null },
              { key: "H4-H6", latestCount: 0, min: null, max: null },
              { key: "Bold/B", latestCount: 0, min: null, max: null }
            ];
            this.characters = [
              { key: "Title", latestWordCount: 0, min: null, max: null },
              { key: "Meta description", latestWordCount: 0, min: 50, max: 160 },
            ];
            this.elements = [
              { key: "H1", latestElementCount: 0, min: null, max: null },
              { key: "H2", latestElementCount: 0, min: null, max: null },
              { key: "H3", latestElementCount: 0, min: null, max: null },
              { key: "H4-H6", latestElementCount: 0, min: null, max: null },
              { key: "Paragraph", latestElementCount: 0, min: null, max: null },
              { key: "Strong/B", latestElementCount: 0, min: null, max: null },
              { key: "Image", latestElementCount: 0, min: null, max: null },
            ];
            this.getEditorDatas();
          })
        }
        if (title === 'AddUrlModal') {
          const data = {
            url: e.value,
            type: "CONTENT"
          }
          this.editorService.getContentDataVieUrl(data).subscribe((res: any) => {
            try {
              // this.loading = false;
              if (res) {
                this.toster.success("Content Imported Successfully");
                this.contentDataViaUrl = res;
                this.titleField = res.title ? res.title : res.h1;
                this.metaField = res.h2 ? res.h2 : res.h3;
                // this.html = res.pContent;
                const delta = this.quillEditor.clipboard.convert({ html: res.pContent });
                let domain = new URL(e.value);
                delta.ops.forEach((e: any) => {
                  if (!!e.attributes && !!e.attributes.link && e.attributes.link !== '' && e.attributes.link !== undefined) {
                    let src = e.attributes.link
                    if (src.indexOf("http") == 0 || src.indexOf("https") == 0) {
                      e.attributes.link = e.attributes.link
                    } else {
                      let isValidUrl = this.checkValidUrl(e.attributes.link);
                      if (!isValidUrl) {
                        e.attributes.link = `${domain.origin}${e.attributes.link}`
                      }
                    }

                  }

                })
                this.quillEditor.setContents(delta, 'silent');
                document.getElementsByClassName('ql-editor')[1].innerHTML = ""
                let innerHtml = (document.getElementsByClassName('ql-editor')[0] as any);
                Object.values(innerHtml?.getElementsByTagName("img"))?.map((x: any) => x.removeAttribute("alt"));
                document.getElementsByClassName('ql-editor')[0].innerHTML = innerHtml.innerHTML;        
                this.saveContent();
                setTimeout(() => {
                  // this.debounce();
                  this.getEditorDatas();
                }, 2500);
                // this.html = res.pContent ? res.pContent : res.divContent;

                // this.quill.root.innerHTML = res.pContent ? res.pContent.replace(/\n/g, " ").replace(/\t/g, '&nbsp;') : res.divContent;
                // this.quill.root.innerHTML = 
              }
            } catch (error: any) {
              this.toster.error(error.message)
            }
          })
        }
        if (title === 'HardRefresh') {
          const data = {
            req_type: "hard_refresh",
            aid: this.cid ? this.cid : ''
          }
          // this.loading = true
          // this.editorService.hardRefreshEditor(data).subscribe((res: any) => {
          //   try {
          //     this.loading = false;
          //     if (res) {
          //       this.toster.success("content data getting successfully");

          //     }
          //   } catch (error: any) {
          //     this.toster.error(error.message)
          //   }
          // })
        }
        if (title === "BriefSetting") {
          this.editorService.saveNotes({ cid: this.cid, note: e }).subscribe(res => {
            this.getEditorDatas();
          })
        }
      });
    } else {
      this.toster.warning("you have to first login to edit this report")
    }

    modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
      this.loading = true;
      this.modalValue = emmitedValue;
      this.h1Data = [];
      this.h2Data = [];
      this.mainContentData = [];
      this.titleData = [];
      let excludedH1: any = [];
      let excludedH2: any = [];
      let excludedMainContent: any = [];
      let excludedTitleData: any = [];
      let ignoredH1: any = [];
      let ignoredH2: any = [];
      let ignoredMainContent: any = [];
      let ignoredTitleData: any = [];
      this.modalValue.forEach(e => {
        if (e.type == "included" && !!e.isH1) {
          if (this.editorData.editor.keywords_h1.find((t: any) => t.keyword == e.keywordName)) {
            this.h1Data.push(this.editorData.editor.keywords_h1.map((el: any) => { el.type = "included"; return { ...el, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, } }).find((t: any) => t.keyword == e.keywordName));
          } else {
            this.h1Data.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, count: 0, type: "included" })
          }
        }

        if (e.type == "included" && !!e.isH2) {
          if (this.editorData.editor.keywords_h2.find((t: any) => t.keyword == e.keywordName)) {
            this.h2Data.push(this.editorData.editor.keywords_h2.map((el: any) => { el.type = "included"; return { ...el, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, } }).find((t: any) => t.keyword == e.keywordName));
          } else {
            this.h2Data.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, count: 0, type: "included" })
          }
        }
        if (e.type == "included" && !!e.isMainContent) {
          if (this.editorData.editor.keywords.find((t: any) => t.keyword == e.keywordName)) {
            this.mainContentData.push(this.editorData.editor.keywords.map((el: any) => { el.type = "included"; return { ...el, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, } }).find((t: any) => t.keyword == e.keywordName));
          } else {
            this.mainContentData.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, score: 0, count: 0, type: "included" })
          }
        }
        if (e.type == "included" && !!e.isTitle) {
          if (this.editorData.editor.keywords_title.find((t: any) => t.keyword == e.keywordName)) {
            this.titleData.push(this.editorData.editor.keywords_title.map((el: any) => { el.type = "included"; return { ...el, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, } }).find((t: any) => t.keyword == e.keywordName));
          } else {
            this.titleData.push({ keyword: e.keywordName, max: 1, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, min: 0, count: 0, type: "included" })
          }
        }
        if (e.type == "excluded" && !!e.isH1) {
          excludedH1.push({ keyword: e.keywordName, max: 1, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, min: 0, count: 0, type: "excluded" })
        }
        if (e.type == "excluded" && !!e.isH2) {
          excludedH2.push({ keyword: e.keywordName, max: 1, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, min: 0, count: 0, type: "excluded" })
          // excludedH2.push(this.editorData.editor.keywords_h2.find((t: any) => t.keyword == e.keywordName));
        }
        if (e.type == "excluded" && !!e.isMainContent) {
          excludedMainContent.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, count: 0, type: "excluded" })
        }
        if (e.type == "excluded" && !!e.isTitle) {
          excludedTitleData.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, count: 0, type: "excluded" })
        }
        if (e.type == "ignored" && !!e.isH1) {
          ignoredH1.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, count: 0, type: "ignored" })
        }
        if (e.type == "ignored" && !!e.isH2) {
          ignoredH1.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, count: 0, type: "ignored" })
        }
        if (e.type == "ignored" && !!e.isMainContent) {
          ignoredMainContent.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, count: 0, type: "ignored" })
        }
        if (e.type == "ignored" && !!e.isTitle) {
          ignoredTitleData.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, count: 0, type: "ignored" })
        }
        if (e.type == "included" && (!e.isH1 && !e.isH2 && !e.isTitle && !e.isMainContent)) {
          ignoredTitleData.push({ keyword: e.keywordName, isH1: e.isH1, isH2: e.isH2, isMainContent: e.isMainContent, isTitle: e.isTitle, max: 1, min: 0, count: 0, type: "ignored" })
        }
      })
      if (!this.uid) {
        this.toster.warning("you have to first login to edit this report")
        return
      }
      let dataObj = {
        cid: this.cid,
        term_ie: {
          inCludedTerms: {
            h1: this.h1Data,
            h2: this.h2Data,
            mainContent: this.mainContentData,
            title: this.titleData,
          },
          excludedTerms: {
            h1: excludedH1,
            h2: excludedH2,
            mainContent: excludedMainContent,
            title: excludedTitleData,
          },
          ignoredTerms: {
            h1: ignoredH1,
            h2: ignoredH2,
            mainContent: ignoredMainContent,
            title: ignoredTitleData,
          },
        }
      }
      this.editorService.updateTerms(dataObj).subscribe(res => {
        this.toster.success("Terms settings saved successfully");
        this.getEditorDatas();
      })
      // do sth with emmitedValue
    });
  }
  checkValidUrl(str: any) {
    var pattern = RegExp('^http[s]?:\/\/((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])');

    return !!pattern.test(str);
  }
  setTitle() {
    // this.editorData.structureCharacters[0].latestWordCount = this.titleField.replace(" ",'').length;
    // this.editorData.structureCharacters[0]['percent'] = ((this.editorData.structureCharacters[0].latestWordCount) * 100) / (this.editorData.structureCharacters[0].max);

    if (this.titleTimoutId) {
      clearTimeout(this.titleTimoutId);
    }
    this.titleTimoutId = setTimeout(() => {
      this.getTagCount();
      this.debounce();
      this.saveContent();
    }, 1000);
  }
  setMetaDesc() {
    // this.editorData.structureCharacters[1].latestWordCount = this.metaField.length;
    // this.editorData.structureCharacters[1]['percent'] = ((this.editorData.structureCharacters[1].latestWordCount) * 100) / (this.editorData.structureCharacters[1].max);
    if (this.metaTimoutId) {
      clearTimeout(this.metaTimoutId);
    }
    this.metaTimoutId = setTimeout(() => {
      this.getTagCount();
      this.debounce();
      this.saveContent();
    }, 1000);
  }
  getTagCount(htmlData?: any) {
    this.getFilteredKeyword();

    let editorData = htmlData;
    let bodyCount: any = [];
    let paragraphCount: any = [];
    let h2Count: any = [];
    let h3Count: any = [];
    let h4Toh6Count: any = [];
    let boldCount: any = [];
    let strongCount = 0;
    let imageCount = 0;
    let htmlConvert: any;
    var oParser: any;
    var oDOM: any;
    var text: any;
    if (!!editorData) {
      htmlConvert = toHTML(editorData);
      oParser = new DOMParser();
      oDOM = oParser.parseFromString(htmlConvert, "text/html");
      text = oDOM.body.innerText;
      this.density[2].latestCount = 0;
      // this.allData.forEach((element) => {
      //   element['count'] = 0;
      if (text !== "") {
        this.density[2].latestCount = text.toLowerCase().split(this.editorData.editor.keyword.toLowerCase()).length - 1;
      }
      // });
    }
    let filteredH1 = editorData?.content.filter((h1: any) => { return h1.type === "heading" && h1.attrs.level == 1 });
    if (this.editorData.editor.term_ie.inCludedTerms?.h1) {
      this.h1Data = this.editorData.editor.term_ie.inCludedTerms?.h1;
    } else {
      this.h1Data = this.editorData.editor?.keywords_h1
    }
    this.h1Data.forEach((element) => {
      element.count = 0;
      this.density[1].latestCount = 0;
      filteredH1?.forEach((el: any) => {
        if (!!el && !!el.content) {
          el?.content?.forEach((e: any) => {
            if (!!e.text && e.text !== "" && e.text !== undefined) {
              const regex = new RegExp("(?<!\\w)" + element.keyword.toLowerCase() + "(?!\\w)", "gi");

              // Find all matches of the keyword in the input string
              const matches = e?.text?.toLowerCase().match(regex);
              // e.text = e.text.toLowerCase();
              element.count += matches?.length > 0 ? matches?.length : 0;
            }
            if (!!e.text && e.text !== "" && e.text !== undefined) {
              const regex = new RegExp("(?<!\\w)" + this.editorData.editor.keyword.toLowerCase() + "(?!\\w)", "gi");
              const matches = e?.text?.toLowerCase().match(regex);
              this.density[1].latestCount = this.density[1].latestCount + matches?.length > 0 ? matches?.length : 0;
              // this.density[1].latestCount = this.density[1].latestCount + e?.text?.toLowerCase().split(this.editorData.editor.keyword.toLowerCase()).length - 1;
            }
          })
        } else {
          element.count = 0;
        }
      })
    });
    // }
    // if(this.activeKeyWord==="H2"){
    let filteredH2 = editorData?.content.filter((h2: any) => { return h2.type === "heading" && h2.attrs.level == 2 });
    if (this.editorData.editor.term_ie.inCludedTerms?.h2) {
      this.h2Data = this.editorData.editor.term_ie.inCludedTerms?.h2;
    } else {
      this.h2Data = this.editorData.editor?.keywords_h2
    }
    this.h2Data.forEach((element) => {
      element.count = 0;
      this.density[4].latestCount = 0;
      filteredH2?.forEach((el: any) => {
        if (!!el && !!el.content) {
          el.content?.forEach((e: any) => {
            if (!!e.text && e.text !== "" && e.text !== undefined) {
              const regex = new RegExp("(?<!\\w)" + element.keyword.toLowerCase() + "(?!\\w)", "gi");

              // Find all matches of the keyword in the input string
              const matches = e?.text?.toLowerCase().match(regex);
              // e.text = e.text.toLowerCase();
              element.count += matches?.length > 0 ? matches?.length : 0;
            }
            if (!!e.text && e.text !== "" && e.text !== undefined) {
              const regex = new RegExp("(?<!\\w)" + this.editorData.editor.keyword.toLowerCase() + "(?!\\w)", "gi");
              const matches = e?.text?.toLowerCase().match(regex);
              // this.density[4].latestCount = this.density[4].latestCount + e?.text?.toLowerCase().split(this.editorData.editor.keyword.toLowerCase()).length - 1;
              this.density[4].latestCount = this.density[4].latestCount + matches?.length > 0 ? matches?.length : 0;

            }
          })
        }
      })
    });
    let mainContentFiltered = editorData?.content.filter((p: any) => { return p.type === "paragraph" });
    this.mainContentData.sort((a, b) => a.keyword.length - b.keyword.length)
    if (this.editorData.editor.term_ie.inCludedTerms?.mainContent) {
      this.mainContentData = this.editorData.editor.term_ie.inCludedTerms?.mainContent;
    } else {
      this.mainContentData = this.editorData.editor?.keywords;
    }
    this.mainContentData.forEach((element) => {
      element.count = 0;
      mainContentFiltered?.forEach((el: any) => {
        if (!!el && !!el.content) {
          el.content?.forEach((e: any) => {
            if (!!e.text && e.text !== "" && e.text !== undefined) {
              // var re = new RegExp("\\b(" + element.keyword.toLowerCase() + ")\\b","gi");
              // var re = new RegExp(`\\b${element.keyword.toLowerCase()}\\b`, 'gi');
              const regex = new RegExp("(?<!\\w)" + element.keyword.toLowerCase() + "(?!\\w)", "gi");

              // Find all matches of the keyword in the input string
              const matches = e?.text?.toLowerCase().match(regex);
              // e.text = e.text.toLowerCase();
              element.count += matches?.length > 0 ? matches?.length : 0;
              // element.count = element.count + e?.text?.toLowerCase().split(re).length - 1;
            }
          })
        }
      })
    });

    editorData?.content?.forEach((el: any) => {
      el?.content?.forEach((e: any) => {
        if (e.type === "text") {
          bodyCount.push(...e?.text?.split(" ").filter((element: any) => element));
        }
        if (el.type === "paragraph") {
          if (e.type === "text") {
            paragraphCount.push(...e?.text?.split(" ").filter((element: any) => element));
          }
        }
        if (el.type === "heading" && el.attrs.level == 2) {
          if (e.type === "text") {
            h2Count.push(...e?.text?.split(" ").filter((element: any) => element));
          }
        }
        if (el.type === "heading" && el.attrs.level == 3) {
          if (e.type === "text") {
            h3Count.push(...e?.text?.split(" ").filter((element: any) => element));
          }
        }
        if ((el.type === "heading" && el.attrs.level == 4 || el.type === "heading" && el.attrs.level == 5 || el.type === "heading" && el.attrs.level == 6)) {
          if (e.type === "text") {
            h4Toh6Count.push(...e?.text?.split(" ").filter((element: any) => element));
          }
        }
        if (e.type === "image") {
          imageCount = imageCount + 1;
        }
        if (!!e.hasOwnProperty('marks')) {
          e.marks.forEach((type: any) => {
            if (type.type === "strong") {
              strongCount = strongCount + 1;
              if (!!e.text) {
                boldCount.push(...e?.text?.split(" ")?.filter((element: any) => element));
                bodyCount.push(...e?.text?.split(" ")?.filter((element: any) => element));
              }
            }
            // else{
            //   boldCount.push(...e?.text?.split(" ").filter((element: any) => element));
            // }
          })
        }
      })
    });
    this.titleData.forEach(title => {
      title['count'] = 0;
      if (this.titleField?.toLowerCase().includes(title.keyword.toLowerCase())) {
        title['count'] += 1;
      }
    })

    this.density.forEach((keyname: any) => {
      keyname['percent'] = ((keyname.latestCount) * 100) / (keyname.max)
    });
    this.getFilteredKeyword();
    this.filterData();
    this.getMinmax();
  }

  filterData() {
    let filteredData;
    if (this.activeKeyWord === "All") {
      filteredData = [...this.mainContentData, ...this.h1Data, ...this.h2Data, ...this.titleData, ...this.top3Data];
      filteredData = filteredData.filter(el => {
        return (el.keyword.toLowerCase().search(this.searchText.toLowerCase()) >= 0)
      });
      this.allData = filteredData;
    }
    if (this.activeKeyWord === "Title") {
      if (!!this.checkObj) {
        filteredData = this.editorData.editor.term_ie.inCludedTerms.title;
      } else {
        filteredData = this.editorData.editor.keywords_title;
      }
      filteredData = filteredData.filter((el: any) => {
        return (el.keyword.toLowerCase().search(this.searchText.toLowerCase()) >= 0)
      });
      this.titleData = filteredData;
    }
    if (this.activeKeyWord === "H1") {
      if (!!this.checkObj) {
        filteredData = this.editorData.editor.term_ie.inCludedTerms.h1;
      } else {
        filteredData = this.editorData.editor.keywords_h1;
      }
      filteredData = filteredData.filter((el: any) => {
        return (el.keyword.toLowerCase().search(this.searchText.toLowerCase()) >= 0)
      });
      this.h1Data = filteredData;
    }
    if (this.activeKeyWord === "H2") {
      if (!!this.checkObj) {
        filteredData = this.editorData.editor.term_ie.inCludedTerms.h2;
      } else {
        filteredData = this.editorData.editor.keywords_h2;
      }
      filteredData = filteredData.filter((el: any) => {
        return (el.keyword.toLowerCase().search(this.searchText.toLowerCase()) >= 0)
      });
      this.h2Data = filteredData;
    }
    if (this.activeKeyWord === "Main content") {
      if (!!this.checkObj) {
        filteredData = this.editorData.editor.term_ie.inCludedTerms.mainContent;
      } else {
        filteredData = this.editorData.editor.keywords
      }
      filteredData = filteredData.filter((el: any) => {
        return (el.keyword.toLowerCase().search(this.searchText.toLowerCase()) >= 0)
      });
      this.mainContentData = filteredData;
    }
    if (this.activeKeyWord === "Top 3") {
      filteredData = this.allData.filter(el => {
        return el.top3 && el.top3 == true;
      })
      filteredData = filteredData.filter(el => {
        return (el.keyword.toLowerCase().search(this.searchText.toLowerCase()) >= 0)
      });
      this.top3Data = filteredData;
    }
    if (this.activeKeyWord === "NLP") {
      if (!!this.checkObj) {
        filteredData = this.editorData.editor.term_ie.inCludedTerms.mainContent.filter((e: any) => { return e.nlp === true });
      } else {
        filteredData = this.editorData.editor.keywords.filter((e: any) => { return e.nlp === true });
      }
      filteredData = filteredData.filter((el: any) => {
        return (el.keyword.toLowerCase().search(this.searchText.toLowerCase()) >= 0)
      });
      this.nlpData = filteredData;
    }
    this.highlightMaster();
    // this.scoreCount();
  }
  resetSearch() {
    if (!!!!this.checkObj) {
      if (this.activeKeyWord === "Title") {
        this.titleData = this.editorData.editor.term_ie.inCludedTerms.title;
      }
      if (this.activeKeyWord === "H1") {
        this.h1Data = this.editorData.editor.term_ie.inCludedTerms.h1;
      }
      if (this.activeKeyWord === "H2") {
        this.h2Data = this.editorData.editor.term_ie.inCludedTerms.h2;
      }
      if (this.activeKeyWord === "Main content") {
        this.mainContentData = this.editorData.editor.term_ie.inCludedTerms.mainContent
      }
      if (this.activeKeyWord === "Top 3") {
        this.top3Data = this.allData.filter(el => {
          return el.top3 && el.top3 == true;
        })
      }
      if (this.activeKeyWord === "NLP") {
        this.nlpData = this.editorData.editor.term_ie.inCludedTerms.mainContent.filter((e: any) => { return e.nlp === true });
      }
    } else {
      if (this.activeKeyWord === "All") {
        this.allData = [...this.mainContentData, ...this.h1Data, ...this.h2Data, ...this.titleData, ...this.top3Data];
      }
      if (this.activeKeyWord === "Title") {
        this.titleData = this.editorData.editor.keywords_title;
      }
      if (this.activeKeyWord === "H1") {
        this.h1Data = this.editorData.editor.keywords_h1;
      }
      if (this.activeKeyWord === "H2") {
        this.h2Data = this.editorData.keywords_h2;
      }
      if (this.activeKeyWord === "Main content") {
        this.mainContentData = this.editorData.editor.keywords
      }
      if (this.activeKeyWord === "Top 3") {
        this.top3Data = this.allData.filter(el => {
          return el.top3 && el.top3 == true;
        })
      }
      if (this.activeKeyWord === "NLP") {
        this.nlpData = this.editorData.editor.keywords.filter((e: any) => { return e.nlp === true });
      }
    }
  }

  saveContent() {
    this.isSaving = true;
    if (!this.uid) {
      this.isSaving = false;
      this.toster.warning("you have to first login to edit this report")
      return
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => {
      let contentObj = {
        score: Math.round(this.score),
        content: document.getElementsByClassName("ql-editor")[0].innerHTML,
        title: this.titleField,
        meta: this.metaField
      };
      this.editorService.saveContent(this.editorData.editor.aid, contentObj).subscribe(res => {
        this.isSaving = false;
      })
      // this.highlightTerms();
    }, 1000);

  }
  filterOptimised(element: any) {
    // let backupAllData: any;
    // backupAllData = [...this.mainContentData, ...this.h1Data, ...this.h2Data, ...this.titleData, ...this.top3Data];
    if (this.isoptimised) {
      if (element.min <= element.count && element.count <= element.max) {
        return true;
      } else {
        return false
      }
    } else {
      return false;
    }
  }
  filterPartial(element: any) {
    if (this.isPartial) {
      if (0 < element.count && element.count < element.min) {
        return true;
      } else {
        return false
      }
    } else {
      return false;
    }
  }
  filterNonUsed(element: any) {
    if (this.isNotUsed) {
      if (element.count == 0) {
        return true;
      } else {
        return false
      }
    } else {
      return false;
    }
  }
  getFilteredKeyword(arg?: string) {
    let backupAllData: any;
    let backupMainContentData: any;
    let backupH1Data: any;
    let backupH2Data: any;
    let backupTitleData: any;
    let backupTop3Data: any;
    let backupNlpData: any;

    // if (this.activeKeyWord === "All") {
    if (!!this.checkObj) {
      backupAllData = [...this.editorData.editor.term_ie.inCludedTerms.mainContent, ...this.editorData.editor.term_ie.inCludedTerms.h1, ...this.editorData.editor.term_ie.inCludedTerms.h2, ...this.editorData.editor.term_ie.inCludedTerms.title];
      backupMainContentData = this.editorData.editor.term_ie.inCludedTerms.mainContent;
      backupH1Data = this.editorData.editor.term_ie.inCludedTerms.h1;
      backupH2Data = this.editorData.editor.term_ie.inCludedTerms.h2;
      backupTitleData = this.editorData.editor.term_ie.inCludedTerms.title;
      backupTop3Data = [...this.editorData.editor.term_ie.inCludedTerms.mainContent, ...this.editorData.editor.term_ie.inCludedTerms.h1, ...this.editorData.editor.term_ie.inCludedTerms.h2, ...this.editorData.editor.term_ie.inCludedTerms.title].filter(el => {
        return el.top3 && el.top3 == true;
      });
      backupNlpData = this.editorData.editor.term_ie.inCludedTerms.mainContent.filter((e: any) => { return e.nlp === true });
    } else {
      backupAllData = [...this.editorData.editor?.keywords, ...this.editorData.editor?.keywords_h1, ...this.editorData.editor?.keywords_h2, ...this.editorData.editor?.keywords_title];
      backupMainContentData = this.editorData.editor?.keywords;
      backupH1Data = this.editorData.editor?.keywords_h1;
      backupH2Data = this.editorData.editor?.keywords_h2;
      backupTitleData = this.editorData.editor?.keywords_title;
      backupTop3Data = [...this.editorData.editor?.keywords, ...this.editorData.editor?.keywords_h1, ...this.editorData.editor?.keywords_h2, ...this.editorData.editor?.keywords_title].filter(el => {
        return el.top3 && el.top3 == true;
      });
      backupNlpData = this.editorData.editor?.keywords.filter((e: any) => { return e.nlp === true });
    }

    if (!this.isoptimised && !this.isPartial && !this.isNotUsed) {
      if (!!this.checkObj) {
        this.allData = [...this.editorData.editor.term_ie.inCludedTerms.mainContent, ...this.editorData.editor.term_ie.inCludedTerms.h1, ...this.editorData.editor.term_ie.inCludedTerms.h2, ...this.editorData.editor.term_ie.inCludedTerms.title];
        this.top3Data = this.allData.filter(el => {
          return el.top3 && el.top3 == true;
        });
        // this.allData = [...this.allData, ...this.top3Data];
        this.mainContentData = this.editorData.editor.term_ie.inCludedTerms.mainContent;
        this.h1Data = this.editorData.editor.term_ie.inCludedTerms.h1;
        this.h2Data = this.editorData.editor.term_ie.inCludedTerms.h2;
        this.titleData = this.editorData.editor.term_ie.inCludedTerms.title;
        this.nlpData = this.editorData.editor.term_ie.inCludedTerms.mainContent.filter((e: any) => { return e.nlp === true });

      } else {
        this.allData = [...this.editorData.editor?.keywords, ...this.editorData.editor?.keywords_h1, ...this.editorData.editor?.keywords_h2, ...this.editorData.editor?.keywords_title];
        this.top3Data = this.allData.filter(el => {
          return el.top3 && el.top3 == true;
        });
        // this.allData = [...this.allData, ...this.top3Data];
        this.mainContentData = this.editorData.editor?.keywords;
        this.h1Data = this.editorData.editor?.keywords_h1;
        this.h2Data = this.editorData.editor?.keywords_h2;
        this.titleData = this.editorData.editor?.keywords_title;
        this.nlpData = this.editorData.editor?.keywords.filter((e: any) => { return e.nlp === true });
      }
    } else {
      this.allData = backupAllData.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      });
      this.mainContentData = backupMainContentData.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
      this.h1Data = backupH1Data.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
      this.h2Data = backupH2Data.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
      this.titleData = backupTitleData.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
      this.top3Data = backupTop3Data.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
      this.nlpData = backupNlpData.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
    }
  }
  download(arg: string) {
    if (arg === 'txt') {
      let oParser = new DOMParser();
      let oDOM = oParser.parseFromString(this.html, "text/html");
      let text = oDOM.body.innerText;
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', this.editorData.editor.keyword);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
    if (arg === 'html') {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/html;charset=utf-8,' + encodeURIComponent(this.html));
      element.setAttribute('download', this.editorData.editor.keyword);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  }
  exportAllDataAsExcel() {
    // let all_data_ary: any = []
    let title_data: any = []
    let h1_data: any = []
    let h2_data: any = []
    let main_content_data: any = []
    let top_30_data: any = []
    let nlp_data: any = []

    // all_data_ary = this.allData.map((v: any) => {
    //   return { keyword: v.keyword, count: v?.count, range: v?.min + "-" + v?.max }
    // })
    title_data = this.titleData.map((v: any) => {
      return { keyword: v.keyword, count: v?.count, range: v?.min + "-" + v?.max, relevancy: 100 }
    })
    h1_data = this.h1Data.map((v: any) => {
      return { keyword: v.keyword, count: v?.count, range: v?.min + "-" + v?.max, relevancy: 100 }
    })
    h2_data = this.h2Data.map((v: any) => {
      return { keyword: v.keyword, count: v?.count, range: v?.min + "-" + v?.max, relevancy: 100 }
    })
    main_content_data = this.mainContentData.map((v: any) => {
      return { keyword: v.keyword, count: v?.count, range: v?.min + "-" + v?.max, relevancy: v?.score }
    })
    top_30_data = this.top3Data.map((v: any) => {
      return { keyword: v.keyword, count: v?.count, range: v?.min + "-" + v?.max }
    })
    nlp_data = this.nlpData.map((v: any) => {
      return { keyword: v.keyword, count: v?.count, range: v?.min + "-" + v?.max }
    })

    // const all_data = XLSX.utils.json_to_sheet(all_data_ary);
    const title = XLSX.utils.json_to_sheet(title_data);
    const h1 = XLSX.utils.json_to_sheet(h1_data);
    const h2 = XLSX.utils.json_to_sheet(h2_data);
    const main_content = XLSX.utils.json_to_sheet(main_content_data);
    const top_30 = XLSX.utils.json_to_sheet(top_30_data);
    const nlp = XLSX.utils.json_to_sheet(nlp_data);

    var Heading = [
      ["Keyword", "Your Count", "Ideal Range", "Relevancy"]
    ];
    var Heading2 = [
      ["Keyword", "Your Count", "Ideal Range"]
    ];

    let wscols1 = [
      { wch: 25, DBF: { name: "Keyword" } },
      { wch: 15, DBF: { name: "Count" } },
      { wch: 15, DBF: { name: "Count2" } },
      { wch: 10, DBF: { name: "Relevancy" } },
    ]
    let wscols2 = [
      { wch: 25, DBF: { name: "Keyword" } },
      { wch: 15, DBF: { name: "Count" } },
      { wch: 15, DBF: { name: "Count2" } },
    ]

    // all_data['!cols'] = wscols1;
    title['!cols'] = wscols1;
    h1['!cols'] = wscols1;
    h2['!cols'] = wscols1;
    main_content['!cols'] = wscols1;
    top_30['!cols'] = wscols2;
    nlp['!cols'] = wscols2;

    // XLSX.utils.sheet_add_aoa(all_data, Heading);
    XLSX.utils.sheet_add_aoa(title, Heading);
    XLSX.utils.sheet_add_aoa(h1, Heading);
    XLSX.utils.sheet_add_aoa(h2, Heading);
    XLSX.utils.sheet_add_aoa(main_content, Heading);
    XLSX.utils.sheet_add_aoa(top_30, Heading2);
    XLSX.utils.sheet_add_aoa(nlp, Heading2);

    const wb = XLSX.utils.book_new();

    // XLSX.utils.book_append_sheet(wb, all_data, `All Data`);
    XLSX.utils.book_append_sheet(wb, title, `Title Tag Keyword`);
    XLSX.utils.book_append_sheet(wb, h1, `H1 Tag Keyword`);
    XLSX.utils.book_append_sheet(wb, h2, `H2 Tag Keyword`);
    XLSX.utils.book_append_sheet(wb, main_content, `Main Content Keyword`);
    XLSX.utils.book_append_sheet(wb, top_30, `Top 3 Keyword`);
    XLSX.utils.book_append_sheet(wb, nlp, `NLP`);

    XLSX.writeFile(wb, `strell_${this.editorData?.editor?.keyword != undefined ? this.editorData?.editor?.keyword : "Content-Editor"}_${new Date().toISOString().split('T')[0]}.xlsx`);

  }
  activeKeyword(arg: string) {
    this.loading = true;
    this.activeKeyWord = arg;
    setTimeout(() => {
      this.highlightMaster();
    }, 500);
  }
  changeTerm() {
    this.loading = true;
    this.isTermHighlighted = !this.isTermHighlighted;
    setTimeout(() => {
      this.highlightMaster();
    }, 500);
  }
  highlightMaster() {
    if (!!this.isTermHighlighted) {
      switch (this.activeKeyWord) {
        case "Main content":
          this.highlightTerms(this.mainContentData)
          break;
        case "Title":
          this.highlightTerms(this.titleData)
          break;
        case "H1":
          this.highlightTerms(this.h1Data)
          break;
        case "H2":
          this.highlightTerms(this.h2Data)
          break;
        case "Top 3":
          this.highlightTerms(this.top3Data)
          break;
        case "NLP":
          this.highlightTerms(this.nlpData)
          break;
        default:
          break;
      }
      this.loading = false;
    } else {
      document.getElementsByClassName('ql-editor')[1].innerHTML = "";
      document.getElementById('highlight-title')!.innerHTML = "";
      this.highlightTerms();
      this.loading = false;
    }
  }
  highlightTerms(array?: any) {
    // document.getElementsByClassName('ql-editor')[1].innerHTML = ""
    let dataArray = array ? array : this.mainContentData;
    let innerHtml = (document.getElementsByClassName('ql-editor')[0] as any);
    // Object.values(innerHtml?.getElementsByTagName("img"))?.map((x: any) => x.removeAttribute("alt"));
    // document.getElementsByClassName('ql-editor')[0].innerHTML = innerHtml.innerHTML;

    document.getElementById('highlight-div')!.innerHTML = innerHtml.innerHTML;
    // let dataArray = array ? array : this.mainContentData;
    // let innerHtml: any = document.getElementsByClassName('ql-editor')[0];
    // const cursorPosition = this.quill ? this.quill.getSelection() : this.quillEditor.getSelection();
    // Object.values(innerHtml?.getElementsByTagName("img"))?.map((x: any) => x.removeAttribute("alt"));
    // innerHtml.innerHTML = innerHtml.innerHTML;
    // this.quill = this.quillEditor
    // this.quillEditor.setSelection(cursorPosition);
    // document.getElementById('highlight-div')!.innerHTML = innerHtml.innerHTML;
    if (this.isTermHighlighted) {
      let a = JSON.stringify(dataArray);
      dataArray = JSON.parse(a);
      dataArray.sort((a: any, b: any) => {
        if (b.keyword.length > a.keyword.length) {
          return 1;
        } else {
          return -1;
        }
      });
      if (this.activeKeyWord === 'Main content') {
        let data: any = document.getElementById('highlight-div');
        data!.childNodes.forEach((el: any) => {
          el.style.color = "transparent";
          if (el.tagName === "P" || el.tagName === "TABLE") {
            let tempHtml = el.innerHTML;
            dataArray.forEach((e: any, index: any) => {
              var re = new RegExp("(?<!\\w)" + e?.keyword + "(?!\\w)", "gi");
              if (e.count == 0 || e.count < e.min) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#ffc222e6;">${matched}</span>`
                });
              } else if (e.count >= e.min && e.count <= e.max) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#009C2C;">${matched}</span>`;
                })
              } else {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#FA726B;">${matched}</span>`
                });
              }
            })
            // this.internalLinkArr?.forEach((el: any, index: any) => {
            //   var re = new RegExp("(?<!\\w)" + el?.keys[0] + "(?!\\w)", "gi");

            //   tempHtml = tempHtml.replaceAll(re, (matched: any) => {
            //     const link = document.createElement('a');
            //     link.href = el.keys[1];
            //     link.target = '_blank';
            //     link.style.textDecoration = 'none';
            //     link.style.backgroundRepeat = 'repeat-x';
            //     link.style.backgroundPosition = 'left 0% bottom 10%';
            //     link.style.pointerEvents = 'all';
            //     link.style.background = 'yellow';
            //     link.style.color = 'cyan';
            //     link.textContent = matched;

            //     // Attach event listener to the link
            //     console.log(link);
            //     console.log(link.outerHTML);
            //     // Attach event listener to the link
            //     link.addEventListener('click', (event) => {
            //       event.stopPropagation();
            //       console.log('clicked');
            //       this.openPopup();
            //     });
            //     return link.outerHTML;
            //     // return `<a target="_blank" style="text-decoration:none;background-repeat: repeat-x;
            //     // background-position: left 0% bottom 10%;pointer-events:all;
            //     // background: yellow;color:cyan" (click)="openPopup()">${matched}</a>`
            //   });
            // })
            el.innerHTML = tempHtml;
          }
        })
        this.showInternalLinks('fromHighlight');
      } else if (this.activeKeyWord === 'H1') {
        let data: any = document.getElementById('highlight-div')
        data!.childNodes.forEach((el: any) => {

          el.style.color = "transparent";
          if (el.tagName === "H1") {
            let tempHtml = el.innerHTML;
            dataArray.forEach((e: any, index: any) => {
              var re = new RegExp("(?<!\\w)" + e?.keyword + "(?!\\w)", "gi");
              if (e.count == 0 || e.count < e.min) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#ffc222e6;">${matched}</span>`
                });
              } else if (e.count >= e.min && e.count <= e.max) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#009C2C;">${matched}</span>`
                });
              } else {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#FA726B;">${matched}</span>`
                });
              }
            })
            el.innerHTML = tempHtml;
          }
          if (el.tagName === "P" || el.tagName === "TABLE") {
            let tempHtml = el.innerHTML;
            dataArray.forEach((e: any, index: any) => {
              var re = new RegExp("(?<!\\w)" + e?.keyword + "(?!\\w)", "gi");
              if (e.count == 0 || e.count < e.min) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#ffc222e6;">${matched}</span>`
                });
              } else if (e.count >= e.min && e.count <= e.max) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#009C2C;">${matched}</span>`;
                })
              } else {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#FA726B;">${matched}</span>`
                });
              }
            })
            // this.internalLinkArr?.forEach((el: any, index: any) => {
            //   var re = new RegExp("(?<!\\w)" + el?.keys[0] + "(?!\\w)", "gi");

            //   tempHtml = tempHtml.replaceAll(re, (matched: any) => {
            //     const link = document.createElement('a');
            //     link.href = el.keys[1];
            //     link.target = '_blank';
            //     link.style.textDecoration = 'none';
            //     link.style.backgroundRepeat = 'repeat-x';
            //     link.style.backgroundPosition = 'left 0% bottom 10%';
            //     link.style.pointerEvents = 'all';
            //     link.style.background = 'yellow';
            //     link.style.color = 'cyan';
            //     link.textContent = matched;

            //     // Attach event listener to the link
            //     link.addEventListener('click', () => {
            //       this.openPopup();
            //     });
            //     return link.outerHTML;
            //     // return `<a target="_blank" style="text-decoration:none;background-repeat: repeat-x;
            //     // background-position: left 0% bottom 10%;pointer-events:all;
            //     // background: yellow;color:cyan" (click)="openPopup()">${matched}</a>`
            //   });
            // })
            el.innerHTML = tempHtml;
          }
        })
        this.showInternalLinks('fromHighlight');
      } else if (this.activeKeyWord === 'H2') {
        let data: any = document.getElementById('highlight-div')
        data!.childNodes.forEach((el: any) => {
          el.style.color = "transparent";
          if (el.tagName === "H2") {
            let tempHtml = el.innerHTML;
            dataArray.forEach((e: any, index: any) => {
              var re = new RegExp("(?<!\\w)" + e?.keyword + "(?!\\w)", "gi");
              if (e.count == 0 || e.count < e.min) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#ffc222e6;">${matched}</span>`
                });
              } else if (e.count >= e.min && e.count <= e.max) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#009C2C;">${matched}</span>`
                });
              } else {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#FA726B;">${matched}</span>`
                });
              }
            })
            el.innerHTML = tempHtml;

          }
          if (el.tagName === "P" || el.tagName === "TABLE") {
            let tempHtml = el.innerHTML;
            dataArray.forEach((e: any, index: any) => {
              var re = new RegExp("(?<!\\w)" + e?.keyword + "(?!\\w)", "gi");
              if (e.count == 0 || e.count < e.min) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#ffc222e6;">${matched}</span>`
                });
              } else if (e.count >= e.min && e.count <= e.max) {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#009C2C;">${matched}</span>`;
                })
              } else {
                tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                  return `<span class="class-remove" style="background:#FA726B;">${matched}</span>`
                });
              }
            })
            // this.internalLinkArr?.forEach((el: any, index: any) => {
            //   var re = new RegExp("(?<!\\w)" + el?.keys[0] + "(?!\\w)", "gi");

            //   tempHtml = tempHtml.replaceAll(re, (matched: any) => {
            //     const link = document.createElement('a');
            //     link.href = el.keys[1];
            //     link.target = '_blank';
            //     link.style.textDecoration = 'none';
            //     link.style.backgroundRepeat = 'repeat-x';
            //     link.style.backgroundPosition = 'left 0% bottom 10%';
            //     link.style.pointerEvents = 'all';
            //     link.style.background = 'yellow';
            //     link.style.color = 'cyan';
            //     link.textContent = matched;

            //     // Attach event listener to the link
            //     link.addEventListener('click', () => {
            //       this.openPopup();
            //     });
            //     return link.outerHTML;
            //     // return `<a target="_blank" style="text-decoration:none;background-repeat: repeat-x;
            //     // background-position: left 0% bottom 10%;pointer-events:all;
            //     // background: yellow;color:cyan" (click)="openPopup()">${matched}</a>`
            //   });
            // })
            el.innerHTML = tempHtml;
          }
        })
        this.showInternalLinks('fromHighlight');
      } else if (this.activeKeyWord === 'Title') {
        document.getElementById('highlight-title')!.innerHTML = this.titleField;
        let data: any = document.getElementById('highlight-title');
        //  data!.childNodes.forEach((el: any) => {
        // if (el.tagName === "H2") {

        dataArray.forEach((e: any, index: any) => {
          var re = new RegExp("(?<!\\w)" + e?.keyword + "(?!\\w)", "gi");

          if (e.count == 0 || e.count < e.min) {
            data.innerHTML = data.innerHTML.replaceAll(re, (matched: any) => {
              return `<span class="class-remove" style="background:#ffc222e6;">${matched}</span>`
            });
          } else if (e.count >= e.min && e.count <= e.max) {
            data.innerHTML = data.innerHTML.replaceAll(re, (matched: any) => {
              return `<span class="class-remove" style="background:#009C2C;">${matched}</span>`
            });
          } else {
            data.innerHTML = data.innerHTML.replaceAll(re, (matched: any) => {
              return `<span class="class-remove" style="background:#FA726B;">${matched}</span>`
            });
          }
        })
        // }
        // })
        document.getElementById('highlight-title')!.innerHTML = data.innerHTML
      } else {
        let data: any = document.getElementById('highlight-div')
        data!.childNodes.forEach((el: any) => {
          let tempHtml = el.innerHTML;
          dataArray.forEach((e: any, index: any) => {
            var re = new RegExp("(?<!\\w)" + e?.keyword + "(?!\\w)", "gi");
            if (e.count == 0 || e.count < e.min) {
              tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                return `<span class="class-remove" style="background:#ffc222e6;">${matched}</span>`
              });
            } else if (e.count >= e.min && e.count <= e.max) {
              tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                return `<span class="class-remove" style="background:#009C2C;">${matched}</span>`
              });
            } else {
              tempHtml = tempHtml.replaceAll(re, (matched: any) => {
                return `<span class="class-remove" style="background:#FA726B;">${matched}</span>`
              });
            }
          })
          el.innerHTML = tempHtml;
        });
      }
    } else {
      if (this.internalLinkArr.length > 0) {
        document.getElementById('highlight-div')!.innerHTML = document.getElementsByClassName('ql-editor')[0].innerHTML;
        let data: any = document.getElementById('highlight-div');
        this.showInternalLinks();
      } else {
        document.getElementById('highlight-div')!.innerHTML = document.getElementsByClassName('ql-editor')[0].innerHTML;
      }
    }
  }
  removeSubstrings(strs: any) {
    return strs.filter((s: any, i: any) => !strs.some((s2: any, j: any) => i !== j && s2.includes(s)));
  }
  scrollHandler(event: any) {
    document.getElementById('highlight-title')!.scrollLeft = document.getElementById('title_text')!.scrollLeft;

  }
  completeEditor() {
    this.editorService.completeEditor({ req_type: "completed" }, this.cid).subscribe(res => {
      this.loading = true;
      this.getEditorDatas();
    })
  }
  Export2Doc(filename = this.editorData.editor.keyword) {
    var html = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta><title>Export HTML To Doc</title></head><body>";
    var footer = "</body></html>";
    var html = html + document.getElementsByClassName('ql-editor')[0]?.innerHTML + footer;

    //link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

    //file name
    // filename = filename ? filename + '.docx' : 'document.docx';
    filename = filename ? `strell_${filename}_${new Date().toISOString().split('T')[0]}.docx` : `strell_document_${new Date().toISOString().split('T')[0]}.docx`;

    // Creates the  download link element dynamically
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    //Link to the file
    downloadLink.href = url;

    //Setting up file name
    downloadLink.download = filename;

    //triggering the function
    downloadLink.click();
    //Remove the a tag after donwload starts.
    document.body.removeChild(downloadLink);
  }
  Export2Html(filename = this.editorData.editor.keyword) {
    var elHtml = document.getElementsByClassName('ql-editor')[0].innerHTML;
    var link = document.createElement('a');
    const mimeType = 'text/plain';
    const elhtml1 = `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta name="description" content='${this.metaField}'>
        <link href='https://fonts.googleapis.com/css2?family=Lato:ital,wght@1,700&family=Merriweather&display=swap' rel='stylesheet'>
        <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap" rel="stylesheet">
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/uikit@3.17.0/dist/css/uikit.min.css" />
        <title>${this.titleField}</title>
        <style>   
          .ql-editor h1 {
              font-size: 48px !important;
              line-height: 58px !important;
          }
      
          // .ql-editor h1 span{
          //     font-size: 48px !important;
          //     line-height: 58px !important;
          // }
      
          .ql-editor h2 {
              font-size: 40px !important;
              line-height: 48px !important;
          }
      
          .ql-editor h3 {
              font-size: 32px !important;
              line-height: 40px !important;
          }
      
          .ql-editor h4 {
              font-size: 24px !important;
              line-height: 28px !important;
          }
      
          .ql-editor h5 {
              font-size: 20px !important;
              line-height: 28px !important;
          }
      
          .ql-editor h6 {
              font-size: 18px !important;
              line-height: 28px !important;
          }
      
          .ql-editor p {
              font-size: 18px !important;
              line-height: 28px !important;
          }
          .ql-editor ul {
              font-size: 18px !important;
              line-height: 28px !important;
          }
          .ql-editor ol {
              font-size: 18px !important;
              line-height: 28px !important;
          }
          .ql-editor table {
              font-size: 18px !important;
              line-height: 28px !important;
          }
      
          .ql-editor blockquote {
              background: #f9f9f9 !important;
              border-left: 10px solid #ccc !important;
              margin: 0 !important;
              padding: 1em 0 0 10px !important;
              padding-bottom: 0 !important;
      
              &:before {
                  color: #ccc !important;
                  font-family: Arial !important;
                  font-size: 4em !important;
                  line-height: 0.1em !important;
                  margin-right: 0.25em !important;
                  vertical-align: -0.4em !important;
              }
      
              & + blockquote {
                  padding: 0 0 0 3.15em !important;
      
                  &:before {
                      display: none !important;
                  }
              }
      
              &:last-of-type {
                  margin-bottom: 1em !important;
                  padding-bottom: 0.5em !important;
              }
      
              p {
                  display: inline !important;
              }
          }
      
          .ql-editor table{
              width: auto;
              overflow: auto;
              min-width: 100px;
          }
          .ql-editor table tr td {
              width: auto;
             }
          .ql-editor table tr:first-child td {
              resize:horizontal;
              overflow:auto;
              width: auto;
             }
      
          // .ql-editor img,iframe {
          //     margin: 15px 0 !important;
          // }
      
          .ql-editor h1,
          .ql-editor h2,
          .ql-editor h3,
          .ql-editor h4,
          .ql-editor h5,
          .ql-editor h6 {
              margin: 15px 0 !important;
          }
      
          // .ql-editor {
          //     border: none !important;
          //     line-height: 1.42 !important;
          //     // margin-top: 150px !important;
          // }
      
          .NgxEditor__MenuBar {
              background-color: #f7f8fa !important;
              padding: 12px !important;
              border-bottom: 1px solid #e6e7eb;
              border-radius: 12px 12px 0 0;
          }
      
          .NgxEditor {
              border: none !important;
              background: transparent !important;
              padding: 0 16px;
          }
      
          .NgxEditor__Content {
              padding: 0 !important;
              padding-top: 24px !important;
          }
      
          .NgxEditor__Seperator {
              border-left: 1px solid #7d7e8026 !important;
          }
      
          .NgxEditor__Placeholder:before {
              color: #7b7d80 !important;
              font-size: 16px;
          }
      
          .NgxEditor__MenuItem--Button {
              border-radius: 4px;
          }
      
          .mat-menu-panel {
              border-radius: 12px !important;
              min-width: 200px !important;
          }
      
          //   .modal-content {
          //       margin: 0 24px !important;
          //       border: 1px solid #f7f8fa;
          //       border-radius: 16px;
          //       width: auto;
          //   }
      
          .NgxEditor {
              min-height: 300px;
          }
      
          .tag-menu {
              background: #111112;
      
              mat-panel-title {
                  color: #ffffff;
              }
      
              .mat-expansion-panel-body {
                  color: #d7d8db;
              }
          }
      
          .providers-menu {
              background: #111112 !important;
              border: 1px solid #0c0c0d;
              box-shadow: 0px 16px 32px -20px rgba(0, 0, 0, 0.9);
      
              .light-neutral {
                  color: #F7F8FA;
              }
      
              .mat-menu-content {
                  color: #f7f8fa;
                  padding: 0 !important;
      
                  .action-btn {
                      color: #d7d8db;
      
                      mat-icon {
                          color: #aaabad;
                      }
                  }
              }
          }
        </style>
    </head>
    <body>
        ${elHtml}
    </body>
    </html>`

    link.setAttribute('download', `${filename}.html`);
    link.setAttribute('href', 'data:' + mimeType + ';charset=utf-8,' + encodeURIComponent(elhtml1));
    link.click();
  }
  filterBriefData() {
    if (this.activeBriefKeyWord === 'H2 brief') {
      this.h2Brief = this.backupH2Brief.filter((el: any) => {
        return (el.title.toLowerCase().search(this.searchBriefText.toLowerCase()) >= 0)
      });
    }
    if (this.activeBriefKeyWord === 'H3 brief') {
      this.h3Brief = this.backupH3Brief.filter((el: any) => {
        return (el.title.toLowerCase().search(this.searchBriefText.toLowerCase()) >= 0)
      });
    }
  }

  logOut() {
    Gleap.clearIdentity();
    localStorage.clear()
    sessionStorage.clear()
    this.cookieServ.delete("uid", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("userName", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("email", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("plan", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("first_name", "/", window.location.hostname, true, "None");
    this.cookieServ.delete("last_name", "/", window.location.hostname, true, "None");
    this.router.navigate(['login']);
  }
  navigateToOutline() {
    const modalRef = this.modal.open(CompetitorsOutlineComponent, { centered: true, windowClass: !this.theme ? 'dark-modal custom-modal' : 'custom-modal' });
    modalRef.componentInstance.outline = this.editorData?.editor?.outline;
    modalRef.componentInstance.eid = this.eid;

    if (!!this.checkBaseOutline) {
      modalRef.componentInstance.baseOutline = JSON.parse(this.editorData?.editor?.baseOutline);
    }

    modalRef.result.then(e => {
      this.editorService.postBaseOutline({ aid: this.eid, baseOutlineData: JSON.stringify(e) }).subscribe(res => {
        this.getEditorDatas();
      })
    })
  }
  modifyBaseOutline() {
    this.newBaseOutlineData = [];
    let parentTag = "h2";
    let parentIndex = 0;
    this.baseOutlineData.forEach((e, index) => {
      this.baseOutlineData[index]['arr'] = [];
      if (this.baseOutlineData[index].tag_name == parentTag) {
        parentTag == this.baseOutlineData[index].tag_name;
        parentIndex = index
      }
      if (parentTag !== this.baseOutlineData[index].tag_name && this.baseOutlineData[index].tag_name !== "h1") {
        this.baseOutlineData[parentIndex].arr.push(this.baseOutlineData[index]);
      }
      if (this.baseOutlineData[index].tag_name !== "h3") {
        this.newBaseOutlineData.push(e);
      }
    });
  }
  appendToEditor() {
    let _data: any = document.getElementsByClassName("ql-editor")[0];
    this.baseOutlineData.forEach(e => {
      let tagName = document.createElement(`${e.tag_name}`);
      tagName.innerText = e.tag_value;
      _data.appendChild(tagName);
    })
  }
  addTag(tagName: string) {
    let obj = {
      level: tagName === 'h2' ? 2 : 3,
      tag_name: tagName,
      tag_value: tagName === 'h2' ? this.h2Tag : this.h3Tag
    }
    this.baseOutlineData.push(obj)
    this.editorService.postBaseOutline({ aid: this.eid, baseOutlineData: JSON.stringify(this.baseOutlineData) }).subscribe(res => {
      this.getEditorDatas();
      this.h2Tag = "";
      this.h3Tag = "";
    })
  }
  drag(ev: any, index: number) {
    ev.dataTransfer.setData("itemToMove", index);
    this.currentDrag = this.baseOutlineData[index];
    // document.getElementById(`div${index}`)!.style.borderTop = "";
  }

  dropp(ev: any, index: number) {
    ev.preventDefault();
    var data = ev.dataTransfer.getData("itemToMove");
    // this.baseOutlineData.splice(index, 0, this.currentDrag);
    let numberOfDeletedElm = 1;

    const elm = this.baseOutlineData.splice(Number(data), numberOfDeletedElm)[0];

    numberOfDeletedElm = 0;

    this.baseOutlineData.splice(index, numberOfDeletedElm, elm);
    document.getElementById(`div${index}`)!.style.borderTop = "";
    // document.getElementById(`dragg${index}`)!.style.display = "none";
  }
  allowDrop(ev: any, index: number) {
    ev.preventDefault();
    document.getElementById(`div${index}`)!.style.borderTop = "1px solid blue";
    // document.getElementById(`dragg${index}`)!.style.display = "flex";
  }
  removeDrag(ev: any, index: number) {
    ev.preventDefault();
    document.getElementById(`div${index}`)!.style.borderTop = "";
    // setTimeout(() => {
    //   document.getElementById(`dragg${index}`)!.style.display = "none";
    // }, 800);

  }
  dropTransfer(ev: any, index: number) {
    ev.preventDefault();
    var data = ev.dataTransfer.getData("itemToMove");
    // this.baseOutlineData.splice(index, 0, this.currentDrag);
    let numberOfDeletedElm = 1;

    const elm = this.baseOutlineData.splice(Number(data), numberOfDeletedElm)[0];
    elm.tag_name = "h2";
    numberOfDeletedElm = 0;

    this.baseOutlineData.splice(index, numberOfDeletedElm, elm);
    document.getElementById(`div${index}`)!.style.borderTop = "";
    // document.getElementById(`divv${index}`)!.innerHTML = document.getElementById(`div${index}`)!.innerHTML;
    // document.getElementById(`div${index}`)!.innerHTML = "";
    this.save()
  }
  dropTransfer1(ev: any, index: number) {
    ev.preventDefault();
    var data = ev.dataTransfer.getData("itemToMove");
    // this.baseOutlineData.splice(index, 0, this.currentDrag);
    let numberOfDeletedElm = 1;

    const elm = this.baseOutlineData.splice(Number(data), numberOfDeletedElm)[0];
    elm.tag_name = "h3";
    numberOfDeletedElm = 0;

    this.baseOutlineData.splice(index, numberOfDeletedElm, elm);
    document.getElementById(`div${index}`)!.style.borderTop = "";
    // document.getElementById(`divv${index}`)!.innerHTML = document.getElementById(`div${index}`)!.innerHTML;
    // document.getElementById(`div${index}`)!.innerHTML = "";
    this.save()
  }
  showDiv(index: any) {
    document.getElementById(`dragg${index}`)!.style.display = "flex";
  }
  hideDiv(index: any) {
    document.getElementById(`dragg${index}`)!.style.display = "none";
  }
  deleteTag(index: number) {
    this.baseOutlineData.splice(index, 1);
    this.isChangeOccured = true;
  }
  // renameTag(index: number, event?: any) {
  //   event?.preventDefault();
  //   // document.getElementById(`editDiv${index}`)!.contentEditable = "true";
  //   this.baseOutlineData[index].tag_value = document.getElementById(`editDiv${index}`)!.innerText;
  //   this.isChangeOccured = true;
  // }
  editTag(index: number, event?: any) {
    event?.preventDefault();
    // document.getElementById(`editDiv${index}`)!.contentEditable = "true";
    this.baseOutlineData[index].tag_name = document.getElementById(`editTag${index}`)!.innerText?.toLowerCase();
    this.isChangeOccured = true;
  }
  save() {
    this.isSaveInProgress = true;
    this.editorService.postBaseOutline({ aid: this.eid, baseOutlineData: JSON.stringify(this.baseOutlineData) }).subscribe(res => {
      this.getEditorDatas('noLoad');
    });
    this.isChangeOccured = false;
  }
  addH2() {
    document.getElementById('h2Tag')!.style.color = "blue"
    setTimeout(() => {
      document.getElementById('h2Tag')!.style.color = ""

    }, 250);
    this.baseOutlineData.push({ tag_name: "h2", tag_value: "", level: 2, isCheck: false, isEditable: true });
  }
  addH3() {
    document.getElementById('h3Tag')!.style.color = "blue"
    setTimeout(() => {
      document.getElementById('h3Tag')!.style.color = ""

    }, 250);
    this.baseOutlineData.push({ tag_name: "h3", tag_value: "", level: 3, isCheck: false, isEditable: true });
  }
  saveTag(index: number) {
    var parentDiv = (document.getElementById(`parentEdit${index}`) as any);
    var div = (document.getElementById(`editDiv${index}`) as any);
    parentDiv.style.background = "";
    parentDiv.style["boxShadow"] = "";
    parentDiv.style.borderRadius = '0'; // standard
    parentDiv.style.padding = '0'; // standard
    this.baseOutlineData[index].tag_value = document.getElementById(`editDiv${index}`)!.innerText;
    // div.style.MozBorderRadius = '0'; // Mozilla
    // div.style.WebkitBorderRadius = '0'; // WebKit     
    div!.contentEditable = "false";
    this.baseOutlineData[index].isEditable = true;
    this.baseOutlineData[index].isCheck = false;
    this.save();
  }
  renameTag(index: number) {
    var parentDiv = (document.getElementById(`parentEdit${index}`) as any);
    var div = (document.getElementById(`editDiv${index}`) as any);
    parentDiv.style.width = "100%"
    parentDiv.style.background = "white";
    parentDiv.style["boxShadow"] = "0 0 5px #999999";
    parentDiv.style.borderRadius = '10px'; // standard
    parentDiv.style.padding = '5px'; // standard
    div!.contentEditable = "true";
    div?.focus();
    this.baseOutlineData[index].isEditable = false;
    this.baseOutlineData[index].isCheck = true;
  }
  renameTagName(index: number, arg: string) {
    this.baseOutlineData[index].tag_name = arg;
  }
  onRightClick(event: any) {
    event.preventDefault();
    let currentEle = event;
    if (currentEle.target.nodeName === 'TD') {
      let toolbar = (document.getElementById('floater') as any);
      var toolbar_width = toolbar.offsetWidth, // get the width and height so we can keep it from squashing at the edge of the page
        toolbar_height = toolbar.offsetHeight;
      var selection_dimensions = currentEle.target.getBoundingClientRect();
      if (toolbar_height + selection_dimensions?.bottom > window.innerHeight) {
        toolbar.style.top = window.innerHeight - (toolbar_height + 10) + "px";
      } else {
        toolbar.style.top = selection_dimensions?.bottom - 10 + "px";
      }

      if (toolbar_width + selection_dimensions?.right > window.innerWidth) {
        toolbar.style.left = window.innerWidth - (toolbar_width + 10) + "px";
      } else {
        toolbar.style.left = selection_dimensions!.right - 100 + "px";
      }

      toolbar.style.display = "block";
      toolbar.style.opacity = 1;
    }
  }
  openUrlModal() {
    // if ('google_token' in localStorage) {
    let modalRef = this.modal.open(CustomUrlComponent, { size: 'xl' });
    modalRef.componentInstance.linkData = this.newInternalLinkArr
    modalRef.componentInstance.html = document.getElementsByClassName('ql-editor')[0];
    modalRef.componentInstance.id = this.eid

    modalRef.result.then((e: any) => {
      this.internalLinkArr = e.data;
      this.createInternalLink();
      this.saveInternalLink();
    })
    // } else {
    //   const authUrl: any = this.editorService.authorizes(this.eid)
    //   window.location.href = authUrl;
    // }
  }
  createInternalLink() {
    if (this.internalLinkArr.length > 0) {
      this.showInternalLinks()
    } else {
      document.getElementById('highlight-div')!.innerHTML = document.getElementsByClassName('ql-editor')[0].innerHTML;
    }
  }
  showInternalLinks(tagData?: any) {
    let data: any;
    if (!!tagData && tagData !== undefined) {
      data = document.getElementById('highlight-div')
    } else {
      document.getElementById('highlight-div')!.innerHTML = document.getElementsByClassName('ql-editor')[0].innerHTML;
      data = document.getElementById('highlight-div');
    }
    let self = this
    function replaceMatches(rootNode: any, link: any) {
      const queue = [rootNode];
      const re = new RegExp("(?<!\\w)" + link.keys[0] + "(?!\\w)", "gi");
      while (queue.length > 0) {
        const node = queue.shift();
        if (node.nodeType === 3) { // Text node
          const text = node.textContent;
          const matches = text.match(re);

          if (matches) {
            let lastIndex = 0;
            for (let i = 0; i < matches.length; i++) {
              const match = matches[i];
              let startIndex = text.indexOf(match, lastIndex);

              // Check if the start index is within the text length
              if (startIndex > text.length) {
                break; // Exit the loop if the start index is greater than the text length
              }

              // Check if the start index is within the node length
              if (startIndex >= node.length) {
                continue; // Skip this iteration if the start index is equal to or greater than the node length
              }

              // Create a new anchor element
              const linkElement = document.createElement('a');
              linkElement.href = link.keys[1];
              linkElement.target = '_blank';
              linkElement.style.textDecoration = 'none';
              linkElement.style.backgroundRepeat = 'epeat-x';
              linkElement.style.backgroundPosition = 'left 0% bottom 10%';
              linkElement.style.pointerEvents = 'all';
              linkElement.style.background = 'yellow';
              linkElement.style.color = 'cyan';
              linkElement.textContent = match;
              linkElement.classList.add("custom-link");
              linkElement.addEventListener('click', (event) => {
                // Your click event handler code here
                self.openPopup(event)
                console.log(`Link clicked: ${linkElement.href}`);
                // You can also call a function or perform any other action here
              });

              // Split the text node into two parts: before the match and after the match
              const beforeMatch = node.splitText(startIndex);
              const afterMatch = beforeMatch.splitText(match.length);

              // Replace the match with the anchor element
              node.parentNode.replaceChild(linkElement, beforeMatch);

              // Insert the after match text node after the anchor element
              node.parentNode.insertBefore(afterMatch, linkElement.nextSibling);
              lastIndex = startIndex + match.length;
            }
          }
        } else if (node.nodeType === 1) { // Element node
          queue.push(...node.childNodes);
        }
      }
    }

    data!.childNodes.forEach((el: any) => {
      if (el.tagName === "P" || el.tagName === "TABLE") {
        this.internalLinkArr.forEach((link) => {
          replaceMatches(el, link);
        });
      }
    });
  }
  openPopup(event?: any) {
    event.preventDefault();
    let currentEle = event;
    if (currentEle.target.nodeName === 'A' && currentEle.target.className === 'custom-link') {
      let toolbar = (document.getElementById('custom-tooltip') as any);
      let customA = (document.getElementById('custom-tooltip-url') as any);
      customA.href = currentEle.target.href
      customA.innerHTML = currentEle.target.href
      var toolbar_width = toolbar.offsetWidth, // get the width and height so we can keep it from squashing at the edge of the page
        toolbar_height = toolbar.offsetHeight;
      var selection_dimensions = currentEle.target.getBoundingClientRect();
      if (toolbar_height + selection_dimensions?.bottom > window.innerHeight) {
        toolbar.style.top = window.innerHeight - (toolbar_height + 10) + "px";
      } else {
        toolbar.style.top = selection_dimensions?.bottom + "px";
      }

      if (toolbar_width + selection_dimensions?.right > window.innerWidth) {
        toolbar.style.left = window.innerWidth - (toolbar_width + 10) + "px";
      } else {
        toolbar.style.left = selection_dimensions!.right - 200 + "px";
      }

      toolbar.style.display = "block";
      toolbar.style.opacity = 1;
    } else {
      let toolbar = (document.getElementById('custom-tooltip') as any);
      toolbar.style.display = "none";
      toolbar.style.opacity = 0;
    }
  }
  saveInternalLink() {
    // let internalLinks = this.internalLinkArr.map(el=>el.keys[0]);
    this.editorService.saveInternalLinks(this.eid, { internal_linking: this.internalLinkArr }).subscribe(res => {
      this.getInternalLinks();
    })
  }
  getInternalLinks() {
    this.editorService.getnternalLinks(this.eid).subscribe(res => {
      this.newInternalLinkArr = res.internal_linking;
      this.internalLinkArr = res.internal_linking;
    })
  }
}